<template>
  <div class="home-page">
    <div class="page-header" style="display: flex; align-items: center; justify-content: space-between; gap: 10px;">
        <h1>愿毕达规划师系统</h1>
        <div style="display: flex; gap: 10px; height: 100%;align-items: top;">
            <!-- 添加首页按钮 -->
            <div style="display: flex; justify-content: space-between; gap: 5px;">
                <!-- 本地数据库按钮 - 仅管理员以上可见 -->
                <button v-if="isSuperAdmin === '超级管理员' || isSuperAdmin === '管理员' || (userVipInfo && userVipInfo.is_admin == true)" class="auth-btn" style="margin-bottom: 0; background-color: #67c23a; color: white;" @click="openLocalServer">本地数据库</button>
                <button class="auth-btn" style="margin-bottom: 0;" @click="goToDashboard">我的</button>
                <button class="auth-btn wishlist-btn" style="margin-bottom: 0; background-color: #67C23A; position: relative;" @click="openWishlistHistory">我的志愿记录<span class="vip-badge">VIP</span></button>
            </div>
            
            <!-- 院校库/专业库按钮 -->
            <button class="auth-btn majors-btn" style="margin-bottom: 0; background-color: #409EFF; height: 69px; display: flex; flex-direction: column; justify-content: center; align-items: center; line-height: 1.4;" @click="goToMajors">
                <span>院校库</span>
                <span>专业库</span>
            </button>

            <!-- 登录/退出按钮 -->
            <div class="auth-buttons" style="display: flex; flex-direction: column; gap: 5px; width: 80px;">
                <div v-if="isLoggedIn" class="user-auth-group" style="display: flex; flex-direction: column; gap: 5px;">
                    <button class="username auth-btn" style="height: 32px; padding: 6px 12px; margin: 0; box-sizing: border-box; line-height: 1.2; position: relative;">
                        {{ username }}
                        <!-- 用户身份角标：优先级 超级管理员 > 管理员 > 规划师 > VIP -->
                        <span v-if="userVipInfo || isSuperAdmin === '超级管理员' || isSuperAdmin === '管理员'" class="user-badge">
                            <template v-if="isSuperAdmin === '超级管理员'">S管理员</template>
                            <template v-else-if="isSuperAdmin === '管理员' || (userVipInfo && userVipInfo.is_admin == true)">管理员</template>
                            <template v-else-if="userVipInfo && userVipInfo.is_svip == true">规划师</template>
                            <template v-else-if="userVipInfo && userVipInfo.is_vip == true">VIP</template>
                        </span>
                    </button>
                    <button class="auth-btn" style="height: 32px; padding: 6px 12px; margin: 0; box-sizing: border-box; line-height: 1.2;" @click="logout">退出登录</button>
                </div>
                <div v-else class="auth-buttons-guest" style="display: flex; flex-direction: column; gap: 5px;">
                    <button class="auth-btn" style="height: 32px; padding: 6px 12px; margin: 0; box-sizing: border-box; line-height: 1.2;" @click="goToLogin">登录</button>
                    <button class="auth-btn" style="height: 32px; padding: 6px 12px; margin: 0; box-sizing: border-box; line-height: 1.2;" @click="goToRegister">注册</button>
                </div>
            </div>

            <!-- 消息和问题反馈按钮组 -->
            <div class="message-feedback-group" style="display: flex; flex-direction: column; gap: 5px; width: 80px;">
                <!-- 消息通知按钮 -->
                <button class="auth-btn message-btn" style="background-color: #2196F3; position: relative; width: 100%; height: 32px; padding: 6px 12px; margin: 0; box-sizing: border-box; line-height: 1.2;" @click="showMessageModal = true">
                    消息
                    <span v-if="unreadMessageCount > 0" class="message-badge">{{ unreadMessageCount }}</span>
                </button>

                <!-- 问题反馈按钮 -->
                <button class="auth-btn feedback-btn" style="background-color: #ff9800; width: 100%; height: 32px; padding: 6px 12px; margin: 0; box-sizing: border-box; line-height: 1.2;" @click="showFeedbackModal = true">问题反馈</button>
            </div>
        </div>
    </div>
    <div class="search-conditions-container" style="position: relative; margin-top: 10px;">  <!-- 添加position:relative -->
        <div class="search-conditions">
          <!-- <form @submit.prevent="submitSearchForm"> -->
            <form> 
            <div class="form-group filter-area-top">
              <div class="form-group" style="flex: 1; min-width: 80px;">
                <label style="white-space: nowrap; display: flex; 
                align-items: center; justify-content: center;">生源地</label>
                <select v-model="formData.origin" style="width: 100%;">
                  <option value="江苏">江苏</option>
                </select>
              </div>
              <div class="form-group" style="flex: 1; min-width: 80px;">
                  <label style="white-space: nowrap; display: flex; 
                  align-items: center; justify-content: center;">年份</label>
                  <select v-model="formData.admit_year" disabled
                  style="width: 100%; background-color: #e0e0e0; cursor: not-allowed;" @keydown="preventKeydown"  @change="fetchRankData">
                    <option :value="maxDataYear-1">{{ maxDataYear-1}}</option>
                    <option :value="maxDataYear">{{ maxDataYear }}</option>
                    <option :value="maxDataYear+1">{{ maxDataYear+1 }}</option>
                  </select>
                </div>
              <div class="form-group" style="flex: 1; min-width: 80px;">
                <label style="white-space: nowrap; display: flex; 
                align-items: center; justify-content: center;">学生姓名</label>
                <div style="position: relative;">
                  <input v-model="formData.student_name" type="text" 
                    style="width: 100%; padding-right: 20px; box-sizing: border-box;">
                  <span v-if="formData.student_name" 
                    @click="formData.student_name = ''" 
                    style="position: absolute; right: 3px; top: 2px; cursor: pointer; color: #f56c6c; font-size: 14px; font-weight: bold; line-height: 1;">
                    ×
                  </span>
                </div>
              </div>
              <div class="form-group" style="flex: 1; min-width: 80px;">
                <label style="white-space: nowrap; display: flex; 
                align-items: center; justify-content: center;">性别</label>
                <select v-model="formData.gender" style="width: 100%;">
                  <option value="男">男</option>
                  <option value="女">女</option>
                </select>
              </div>
              <div class="form-group" style="flex: 1; min-width: 80px;">
                <label style="white-space: nowrap; 
                display: flex; align-items: center; 
                justify-content: center;">填报类型</label>
                <select v-model="formData.batch" style="width: 100%;">
                  <option value="本科批">本科批</option>
                  <option value="本科提前批">本科提前批</option>
                  <option value="专科提前批">专科提前批</option>
                  <option value="专科批">专科批</option>
                </select>
              </div>
              <div v-show="showEnrollmentType" class="form-group" style="flex: 1; min-width: 80px;">
                <label style="white-space: nowrap; 
                display: flex; align-items: center; 
                justify-content: center;">招生类型</label>
                <select v-model="formData.enrollment_type" style="width: 100%;">
                  <option value="">全选</option>
                  <option v-for="option in enrollmentTypeOptions" :key="option.value" :value="option.value">
                    {{ option.label }}
                  </option>
                </select>
              </div>
              <div class="filter-area-full-row" style="display: flex; align-items: center; 
              gap: 10px;margin-top: 10px;">
                <label style="white-space: nowrap;">科类</label>
                <div class="range-settings" style="display: flex; 
                gap: 5px;">
                  <div>
                    <select v-model="formData.subject1" 
                    style="width: 130px;"
                    @change="handleSubjectChange">
                      <option value="物理">物理</option>
                      <option value="历史">历史</option>
                    </select>
                  </div>
                  <div>
                    <select v-model="formData.subject2" 
                    style="width: 130px;">
                      <option value="化学">化学</option>
                      <option value="生物">生物</option>
                      <option value="政治">政治</option>
                      <option value="地理">地理</option>
                    </select>
                  </div>
                  <div>
                    <select v-model="formData.subject3" 
                    style="width: 130px;">
                      <option value="生物">生物</option>
                      <option value="化学">化学</option>
                      <option value="政治">政治</option>
                      <option value="地理">地理</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group filter-area-bottom">
              <div class="form-group" style="flex: 1; min-width: 80px;">
                <label style="white-space: nowrap;
                display: flex; align-items: center;
                justify-content: center;">分数</label>
                <input v-model="formData.scr_line"
                type="number" min="420" step="1" max="750" value="600"
                       :disabled="scoreChangeInfo.remaining === 0"
                       style="width: 100%;"
                       :style="{ backgroundColor: scoreChangeInfo.remaining === 0 ? '#e0e0e0' : '', cursor: scoreChangeInfo.remaining === 0 ? 'not-allowed' : '' }"
                       @change="handleScoreChange"
                       @keydown.enter="handleScoreChange">
              </div>
              <div class="form-group" style="flex: 1; min-width: 80px;">
                <label style="white-space: nowrap; 
                display: flex; align-items: center; 
                justify-content: center;">位次</label>
                <input v-model="formData.admission_rank" 
                type="number" min="1"
                :disabled="isSuperAdmin != '超级管理员' && !(userVipInfo && (userVipInfo.is_admin || userVipInfo.is_svip))"
                style="width: 100%;"
                :style="{ backgroundColor: isSuperAdmin != '超级管理员' && !(userVipInfo && (userVipInfo.is_admin || userVipInfo.is_svip)) ? '#f5f5f5' : '', cursor: isSuperAdmin != '超级管理员' && !(userVipInfo && (userVipInfo.is_admin || userVipInfo.is_svip)) ? 'not-allowed' : '' }">
              </div>
              <div class="form-group" style="flex: 1; min-width: 80px;">
                <label style="white-space: nowrap; 
                display: flex; align-items: center; 
                justify-content: center;">同位分人数</label>
                <input v-model="formData.same_rank_score" 
                type="number" min="1" readonly style="width: 100%; 
                background-color: #f5f5f5;">
              </div>
              <div class="filter-area-full-row" style="display: flex; align-items: center; 
              gap: 10px;margin-top: 10px;">
                <label style="white-space: nowrap;">位次冲稳保设置</label>
                <div class="range-settings" style="display: flex; gap: 5px;">
                  <div style="display: flex; align-items: center; gap: 5px;">
                    <input v-model="formData.rush_rank" type="number" 
                    min="0" step="0.1" value="0.2" style="width: 60px;">
                  </div>
                  <div style="display: flex; align-items: center; gap: 5px;">
                    <input v-model="formData.stable_rank" type="number" 
                    min="0" step="0.1" value="0.2" style="width: 60px;">
                  </div>
                  <div style="display: flex; align-items: center; gap: 5px;">
                    <input v-model="formData.safe_rank" type="number" 
                    min="0" step="0.1" value="1" style="width: 60px;">
                  </div>
                </div>
              </div>
              <!-- 新增模拟填报和剩余次数显示框 -->
              <div class="filter-area-full-row" style="display: flex; align-items: center; gap: 10px;
               margin-top: 10px;">
                <div style="display: flex; align-items: center; gap: 5px;">
                  <label style="white-space: nowrap;">模拟or正式:</label>
                  <input v-model="mockOrOfficial" type="text" readonly 
                  style="width: 100px; background-color: #f5f5f5;">
                </div>
                <div style="display: flex; align-items: center; gap: 5px;">
                  <label style="white-space: nowrap;">剩余次数:</label>
                  <input :value="scoreChangeInfo.remaining >= 0 && scoreChangeInfo.remaining < 999 ? scoreChangeInfo.remaining + ' 次' : '无限制'" type="text" readonly style="width: 120px;
                  background-color: #e0e0e0;">
                </div>
              </div>
            </div>
            <div class="form-group">
              <table class="professional-table">
                <thead>
                  <tr>
                    <th>专业名称</th>
                    <th>汇总标签</th>
                    <th>学校名</th>
                    <th>学校省份</th>
                    <th>学校性质</th>
                    <th>专业备注</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(row, index) in professionalRows"
                    :key="index"
                    @touchstart="handleRowTouchStart($event, row, index)"
                    @touchend="handleRowTouchEnd($event, row, index)"
                    @touchmove="handleRowTouchMove"
                    @contextmenu="handleContextMenu($event, row, index)"
                    style="user-select: none; -webkit-user-select: none; -webkit-touch-callout: none;"
                  >
                    <td data-label="专业名称">
                      <input v-model="row.professional" 
                      list="professionals" 
                      @change="blurInput" 
                      @focus="clearInput"
                      style="width: 100%; ">
                      <datalist id="professionals">
                        <option value=" ">不选择</option>
                        <option value="计算机科学与技术">计算机科学与技术</option>
                        <option value="软件工程">软件工程</option>
                        <option value="人工智能">人工智能</option>
                        <option value="数据科学与大数据技术">数据科学与大数据技术</option>
                      </datalist>
                    </td>
                    <td data-label="汇总标签">
                      <input v-model="row.tag" 
                      list="tags" 
                      @change="blurInput" 
                      @focus="clearInput"
                      style="width: 100%; "
                      >
                      <datalist id="tags">
                        <option value=" ">不选择</option>
                        <option value="985">985</option>
                        <option value="211">211</option>
                      </datalist>
                    </td>
                    <td data-label="学校名">
                      <div style="position: relative;">
                        <input v-model="row.schoolName" 
                          @change="blurInput" 
                          style="width: 100%; padding-right: 25px; box-sizing: border-box;"
                        >
                        <span v-if="row.schoolName" 
                          @click="row.schoolName = ''" 
                          style="position: absolute; right: 5px; top: 2px; cursor: pointer; color: #f56c6c; font-size: 16px; font-weight: bold; line-height: 1;">
                          ×
                        </span>
                      </div>
                    </td>
                    <td data-label="学校省份">
                      <input v-model="row.schoolProvince" 
                      list="school_provinces" 
                      @change="blurInput" 
                      @focus="clearInput"
                      style="width: 100%;"
                      >
                      <datalist id="school_provinces">
                        <option value=" ">不选择</option>
                        <option value="江苏">江苏</option>
                        <option value="安徽"></option>
                        <option value="北京"></option>
                        <option value="重庆"></option>
                        <option value="福建"></option>
                        <option value="甘肃"></option>
                        <option value="广东"></option>
                        <option value="广西"></option>
                        <option value="贵州"></option>
                        <option value="海南"></option>
                        <option value="河北"></option>
                        <option value="河南"></option>
                        <option value="黑龙江"></option>
                        <option value="湖北"></option>
                        <option value="湖南"></option>
                        <option value="吉林"></option>
                        <option value="江西"></option>
                        <option value="辽宁"></option>
                        <option value="内蒙古"></option>
                        <option value="宁夏"></option>
                        <option value="青海"></option>
                        <option value="山东"></option>
                        <option value="上海"></option>
                        <option value="山西"></option>
                        <option value="陕西"></option>
                        <option value="四川"></option>
                        <option value="天津"></option>
                        <option value="西藏">西藏</option>
                        <option value="新疆">新疆</option>
                        <option value="云南">云南</option>
                        <option value="浙江">浙江</option>
                      </datalist>
                    </td>
                    <td data-label="学校性质">
                      <input v-model="row.schoolType" 
                      list="schoolType" 
                      @change="blurInput" 
                      @focus="clearInput"
                      style="width: 100%;"
                      >
                      <datalist id="schoolType">
                        <option value=" ">不选择</option>
                        <option value="公办">公办</option>
                        <option value="民办">民办</option>
                      </datalist>
                    </td>
                    <td data-label="专业备注">
                      <input v-model="row.professionalRemark" 
                      list="professional_remarks" 
                      @change="blurInput" 
                      @focus="clearInput"
                      style="width: 100%;"
                      >
                      <datalist id="professional_remarks">
                        <option value=" ">不选择</option>
                        <option value="分段培养">分段培养</option>
                        <option value="师范">师范</option>
                        <option value="中外合作">中外合作</option>
                      </datalist>
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- 上下文菜单 -->
              <div
                v-if="contextMenuVisible"
                class="context-menu"
                :style="{ left: contextMenuX + 'px', top: contextMenuY + 'px' }"
              >
                <div class="context-menu-item" @click="contextMenuAction('addToWishList')">
                  添加到志愿表
                </div>
                <div class="context-menu-item" @click="contextMenuAction('viewDetail')">
                  查看详情
                </div>
                <div class="context-menu-item" @click="contextMenuAction('copy')">
                  复制学校名
                </div>
              </div>

              <!-- 修改为两行布局 -->
              <div class="button-group" style="display: flex; 
              flex-direction: column; gap: 15px;">
                <!-- 第一行：增加条件和删除条件按钮 -->
                <div class="condition-buttons-row" style="display: flex; gap: 10px;">
                  <button type="button" class="add-btn" 
                  @click="generateTableRows(1)">
                    增加条件
                  </button>
                  <button type="button" class="remove-btn" 
                  @click="removeLastRow">
                    删除条件
                  </button>

                   <!-- 超级管理员才显示的整理数据按钮 -->
                  <div v-if="isSuperAdmin==='超级管理员'" class="admin-buttons-group" style="display: flex; gap: 10px; align-items: center;">
                    <div style="display: flex; align-items: center; height: 32px;">
                      <select v-model="modifyTableName" style="width: 110px;">
                        <option value="原始数据">原始数据</option>
                        <option value="上1年导入">上1年导入</option>
                        <option value="招生计划">招生计划</option>
                      </select>
                    </div>
                 
                    <!-- <button v-if="isSuperAdmin" type="button" class="add-btn"  -->
                    <button type="button" class="admin-btn2" 
                    @click="headerChange">
                    的表头调整
                    </button>
                    <button type="button" class="admin-btn2" 
                    @click="updateSchoolNames">
                    多表学校名更改
                    </button>
                    <button  type="button" class="admin-btn2" 
                    @click="planchange">
                    修改(招生计划)列到其他列
                    </button>
                    <button  type="button" class="admin-btn" 
                    @click="organizeCollegeData">
                      (原始数据)加（省城市标签）
                    </button>
                  
                    <button type="button" class="admin-btn" 
                    @click="organizeMajorNames('check')">
                    检查(原始数据)列到其他列
                    </button>
                    <button type="button" class="admin-btn" 
                    @click="organizeMajorNames('edit')">
                    修改(原始数据)列到其他列
                    </button>
                    <button type="button" class="admin-btn" 
                    @click="checkConsecutiveMajors">
                    检查连续相同专业
                    </button>
                    <button type="button" class="admin-btn" 
                    @click="modifyMajorGroupCutoff">
                    修改专业组投档线
                    </button>
                    </div>
                </div>
                
                <!-- 修改按钮区域样式，使其填满整行 -->
                <div style="display: flex; gap: 10px; width: 100%;" class="action-buttons-row">
                  <button type="button" class="search-btn" style="flex: 1;"
                  @click="handleFilterSearch" :disabled="isLoading">
                  <i v-if="isLoading" class="el-icon-loading"></i>
                  {{ isLoading ? '加载中...' : '筛选志愿' }}
                  </button>
                  <button v-if="hasSvipPermission" type="button" class="wish-button vip-badge-svip" style="flex: 1; position: relative;"
                  @click="handleExportFilteredData">导出所有符合数据<span class="feature-badge">规划师</span></button>
                  <button type="button" class="wish-button" style="flex: 1;" @click="handleSaveColumnWidths">
                            保存列宽</button>
                  <button type="button" class="wish-button" style="flex: 1;" @click="restoreDefaultColumnWidths">
                            恢复默认列宽</button>
                  <button class="remove-btn" style="flex: 1;"
                  @click.prevent="scrollTo('wish-table')">移动志愿表</button>
                </div>
                
              </div>
            </div>
 
            <!-- 在筛选表标题附近添加 -->
            <div id="filter-table" ref="filteredTableTitle" style="display: flex; justify-content: center; align-items: center; gap: 15px; margin: 15px 0;">
              <h3 style="color: #409EFF; font-weight: bold; font-size: 18px; text-shadow: 1px 1px 2px rgba(0,0,0,0.1); margin: 0; white-space: nowrap;">筛选表<span v-if="isLocalDatabase">（本地数据库）</span></h3>
              <div v-if="mockOrOfficial === '模拟填报'" style="color: #f56c6c; font-size: 14px; margin: 0;">
                
                （当前模式为"模拟填报"，"正式填报"时请不要用）
              </div>
              <button v-if="hasActiveColumnFilters" type="button"
                class="column-filter-btn"
                style="margin-left: 10px;"
                @click="clearAllColumnFilters">
                清空列筛选
              </button>
            </div>   

            <!-- 添加登录提醒信息 -->
            <div style="display: flex; justify-content: center; align-items: center; gap: 20px; margin: 15px 0;">
              <div v-if="['用户','0'].includes(isSuperAdmin) && (!vipInfo?.is_vip || vipInfo?.is_expired)"  style="color: #f56c6c; margin: 10px 0; font-size: 14px;">
                <span v-if="!vipInfo?.is_vip">（当前状态：非VIP，在↗角'我的'激活VIP）</span>
                <span v-else-if="vipInfo?.is_expired">（您的VIP已过期，请续费）</span>
              </div>
            </div>

          </form>
          <!-- <div class="main-content"> -->
             
            <!-- 修改el-table组件部分，添加一个ref属性 -->
            <!-- 移除不必要的懒加载相关配置 -->
            <el-table
            ref="dataTable"
            :data="displayFilteredData"
            class="custom-table"
            border
            :style="{width: tableWidthSettings.overallWidth || '100%'}"
            height="600px"
            v-loading="isLoading"
            element-loading-text="数据加载中..."
            element-loading-spinner="el-icon-loading"
            highlight-current-row
            @load="handleTableLoad"
            @row-click="selectItem"
            @row-contextmenu="handleRightClick"
            @row-dblclick="showFullContent"
            @cell-mouse-enter="showHoverTooltip"
            @cell-mouse-leave="hideHoverTooltip"
            @cell-click="showContentOnSmallScreen"
            @scroll.native="handleTableScroll"
            @header-dragend="onColumnResizeEnd"
            header-cell-class-name="blue-header"
            :row-class-name="getRowClassName"
            :cell-class-name="getCellClassName"
            :row-height="40"  
            :virtual-scroll="true"
            :buffer-size="5"  
            :scrollbar-always-on="true">
           
           
            <!-- 修改el-table-column部分 -->
            <el-table-column
              v-for="key in tableColumnKeys"
              :key="key"
              :prop="key"
              :label="formatColumnName(key)"
              :width="getColumnWidth(formatColumnName(key))"
              header-align="center"
              align="center"
              resizable>
              <template #header>
                <el-popover
                  :ref="'filterPopover_' + key"
                  v-model="showColumnFilter[key]"
                  placement="bottom"
                  :width="280"
                  trigger="click"
                  popper-class="column-filter-popover">
                  <div class="column-filter-popover-content">
                    <el-input
                      v-model="columnFilterSearchText[key]"
                      placeholder="搜索选项..."
                      size="mini"
                      prefix-icon="el-icon-search"
                      clearable
                      style="margin-bottom: 6px;">
                    </el-input>
                    <div class="filter-option-list">
                      <label class="filter-option-item select-all">
                        <input type="checkbox"
                          :checked="isAllFilterSelected(key)"
                          @change="toggleSelectAllFilter(key, $event.target.checked)">
                        <span class="filter-option-text">全选 ({{ getColumnUniqueOptions(key).length }})</span>
                      </label>
                      <label class="filter-option-item" v-for="opt in getFilteredOptions(key)" :key="opt">
                        <input type="checkbox"
                          :checked="isFilterOptionSelected(key, opt)"
                          @change="toggleFilterOption(key, opt)">
                        <span class="filter-option-text">{{ opt || '(空)' }}</span>
                      </label>
                    </div>
                    <div class="filter-option-count">
                      已选 {{ (columnFilterValues[key] || []).length }} 项
                    </div>
                    <div class="column-filter-actions">
                      <el-button size="mini" type="primary" @click="applyColumnFilter(key)">确定</el-button>
                      <el-button size="mini" @click="clearColumnFilter(key)">清除</el-button>
                    </div>
                  </div>
                  <div
                    slot="reference"
                    class="column-filter-header"
                    :class="{ 'filter-active': columnFilterValues[key] && columnFilterValues[key].length }"
                    :title="(columnFilterValues[key] && columnFilterValues[key].length) ? '已选' + columnFilterValues[key].length + '项' : '点击筛选此列'">
                    <span class="column-filter-label">{{ formatColumnName(key) }}</span>
                    <i v-if="columnFilterValues[key] && columnFilterValues[key].length" class="el-icon-s-operation column-filter-badge"></i>
                  </div>
                </el-popover>
              </template>
              <!-- 最低位次：悬停显示位次趋势折线图（含最高位次）+ 招生数图；最高位次不弹窗 -->
              <template v-if="key === 'l_rnk'" #default="{ row }">
                <el-popover
                  v-if="row.rank_trend"
                  trigger="hover"
                  placement="right"
                  :width="220"
                  popper-class="rank-trend-popover"
                  :open-delay="200"
                >
                  <div class="trend-popover-inner">
                    <!-- 位次趋势图 -->
                    <div class="trend-chart-title">位次趋势</div>
                    <svg :width="200" :height="50" class="trend-chart-svg">
                      <!-- l_rnk 趋势线（蓝色） -->
                      <polyline
                        :points="getTrendLinePath(row.rank_trend, 'l_rnk')"
                        fill="none"
                        stroke="#409EFF"
                        stroke-width="2"
                        stroke-linejoin="round"
                      />
                      <!-- l_rnk 数据点 -->
                      <circle
                        v-for="(dot, di) in getTrendDots(row.rank_trend, 'l_rnk')"
                        :key="'l'+di"
                        :cx="dot.x"
                        :cy="dot.y"
                        r="3"
                        fill="#409EFF"
                        stroke="#fff"
                        stroke-width="1"
                      >
                        <title>{{ dot.year }}年 最低位次 {{ dot.rank }}名</title>
                      </circle>
                      <!-- h_rnk 趋势线（红色） -->
                      <polyline
                        :points="getTrendLinePath(row.rank_trend, 'h_rnk')"
                        fill="none"
                        stroke="#F56C6C"
                        stroke-width="2"
                        stroke-linejoin="round"
                      />
                      <!-- h_rnk 数据点 -->
                      <circle
                        v-for="(dot, di) in getTrendDots(row.rank_trend, 'h_rnk')"
                        :key="'h'+di"
                        :cx="dot.x"
                        :cy="dot.y"
                        r="3"
                        fill="#F56C6C"
                        stroke="#fff"
                        stroke-width="1"
                      >
                        <title>{{ dot.year }}年 最高位次 {{ dot.rank }}名</title>
                      </circle>
                      <!-- 用户位次虚线 -->
                      <line
                        v-if="formData.admission_rank"
                        :x1="14" :y1="getUserRankY(row.rank_trend)"
                        :x2="186" :y2="getUserRankY(row.rank_trend)"
                        stroke="#E6A23C"
                        stroke-width="1.5"
                        stroke-dasharray="5,3"
                      />
                    </svg>
                    <div class="trend-legend">
                      <span class="trend-legend-item">
                        <span class="trend-legend-line lrnk-line"></span>最低
                      </span>
                      <span class="trend-legend-item">
                        <span class="trend-legend-line hrnk-line"></span>最高
                      </span>
                      <span v-if="formData.admission_rank" class="trend-legend-item">
                        <span class="trend-legend-line myrnk-line"></span>我的{{ formData.admission_rank }}
                      </span>
                    </div>
                    <!-- 招生数图 -->
                    <div class="trend-chart-title">招生数</div>
                    <svg :width="200" :height="50" class="trend-chart-svg">
                      <!-- 计划数（plan）虚线 -->
                      <polyline
                        :points="getEnrollmentLinePath(row.rank_trend, 'plan')"
                        fill="none"
                        stroke="#67C23A"
                        stroke-width="2"
                        stroke-linejoin="round"
                        stroke-dasharray="5,3"
                      />
                      <!-- 往年数（pre_pl）实线 -->
                      <polyline
                        :points="getEnrollmentLinePath(row.rank_trend, 'pre_pl')"
                        fill="none"
                        stroke="#909399"
                        stroke-width="2"
                        stroke-linejoin="round"
                      />
                      <!-- plan 数据点 -->
                      <circle
                        v-for="(dot, di) in getEnrollmentDots(row.rank_trend, 'plan')"
                        :key="'p'+di"
                        :cx="dot.x" :cy="dot.y" r="2.5"
                        fill="#67C23A" stroke="#fff" stroke-width="0.5"
                      >
                        <title>{{ dot.year }}年 计划数 {{ dot.val }}人</title>
                      </circle>
                      <!-- pre_pl 数据点 -->
                      <circle
                        v-for="(dot, di) in getEnrollmentDots(row.rank_trend, 'pre_pl')"
                        :key="'pp'+di"
                        :cx="dot.x" :cy="dot.y" r="2.5"
                        fill="#909399" stroke="#fff" stroke-width="0.5"
                      >
                        <title>{{ dot.year }}年 往年数 {{ dot.val }}人</title>
                      </circle>
                    </svg>
                    <div class="trend-legend">
                      <span class="trend-legend-item">
                        <span class="trend-legend-line plan-line"></span>计划数
                      </span>
                      <span class="trend-legend-item">
                        <span class="trend-legend-line prepl-line"></span>往年数
                      </span>
                    </div>
                    <!-- 逐年数据表 -->
                    <div class="trend-years-data">
                      <div v-for="d in parseTrendData(row.rank_trend)" :key="d.year" class="trend-year-row">
                        <span class="trend-year">{{ d.year }}年</span>
                        <span class="trend-lrnk">{{ d.l_rnk != null ? d.l_rnk : '--' }}</span>
                        <span class="trend-ecnt">{{ d.plan != null ? d.plan : '--' }}</span>
                        <span class="trend-ecnt-pre">{{ d.pre_pl != null ? d.pre_pl : '--' }}</span>
                      </div>
                    </div>
                  </div>
                  <span slot="reference" class="rank-value-hoverable">{{ row[key] }}</span>
                </el-popover>
                <span v-else>{{ row[key] }}</span>
              </template>
              <!-- 专业名称：悬停显示考研方向 -->
              <template v-else-if="key === 'major_name'" #default="{ row }">
                <el-popover
                  trigger="hover"
                  placement="top"
                  :open-delay="200"
                  :disabled="!row.grad_dir && !row.main_sub && !row.job_dir"
                  popper-class="major-graddir-popover"
                >
                  <div v-if="row.main_sub" class="graddir-label">专业课程</div>
                  <div v-if="row.main_sub" class="graddir-content">{{ row.main_sub }}</div>
                  <div v-if="row.main_sub && row.grad_dir" class="graddir-divider"></div>
                  <div v-if="row.grad_dir" class="graddir-label">考研方向</div>
                  <div v-if="row.grad_dir" class="graddir-content">{{ row.grad_dir }}</div>
                  <div v-if="(row.grad_dir || row.main_sub) && row.job_dir" class="graddir-divider"></div>
                  <div v-if="row.job_dir" class="graddir-label">就业方向</div>
                  <div v-if="row.job_dir" class="graddir-content">{{ row.job_dir }}</div>
                  <span slot="reference" class="maj-name-cell" :class="{ 'maj-name-hoverable': row.grad_dir || row.main_sub || row.job_dir }">{{ row[key] }}</span>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
          
          <!-- 添加分页组件 -->
          <!-- 修改分页组件，使用Vue 2兼容的语法 -->
          <div class="pagination-container" style="margin-top: 20px; text-align: center;">
            <!-- 第一行：共X个学校、每页条数和跳转 -->
            <div class="pagination-row first-row" style="gap: 15px;">
              <span style="display: inline-flex; 
                    align-items: center; height: 32px; color: #409EFF;"
                    >共{{ schoolCount }}个学校</span>
              <select
                v-if="isSuperAdmin === '超级管理员' || isSuperAdmin === '管理员' || (userVipInfo && userVipInfo.is_admin == true)"
                v-model.number="pagination.pageSize"
                @change="handleSizeChange(pagination.pageSize)"
                style="font-size: 14px; padding: 6px 10px; border: 1px solid #dcdfe6; border-radius: 4px; vertical-align: top;">
                <option :value="1">1个学校/页</option>
                <option :value="5">5个学校/页</option>
                <option :value="10">10个学校/页</option>
                <option :value="20">20个学校/页</option>
              </select>
              <el-pagination
                :current-page="pagination.currentPage"
                :page-size="pagination.pageSize"
                layout="jumper"
                :total="schoolCount"
                @current-change="handleCurrentChange"
                style="font-size: 14px; display: inline-block; vertical-align: top;"
                class="large-pagination"
              />
              <!-- 非第1页时显示VIP钻石提示 -->
              <span v-if="pagination.currentPage > 1" 
                    style="color: #FFD700; font-size: 16px;"
                    title="VIP功能">💎</span>
            </div>
            
            <!-- 第二行：页码 -->
            <div class="pagination-row second-row custom-pagination">
              <button 
                class="pagination-btn" 
                :disabled="pagination.currentPage === 1"
                @click="handleCurrentChange(pagination.currentPage - 1)">
                上一页
              </button>
              <div class="page-numbers">
                <button 
                  v-for="(page, index) in displayedPages" 
                  :key="page + '-' + index"
                  class="page-number"
                  :class="{ active: pagination.currentPage === page, 'page-vip': index >= 1 && page !== '...' }"
                  :disabled="page === '...'"
                  @click="handleCurrentChange(page)">
                  {{ page }}
                  <span v-if="index >= 1 && page !== '...'" class="page-vip-badge">VIP</span>
                </button>
              </div>
              <button 
                class="pagination-btn next-page-btn"
                :disabled="pagination.currentPage === totalPages"
                @click="handleCurrentChange(pagination.currentPage + 1)">
                下一页<span class="page-vip-badge">VIP</span>
              </button>
            </div>
            
          </div>
          
          <!-- <div slot="append" v-if="isLoadingMore">
            <div style="padding: 10px; text-align: center;">
              <i class="el-icon-loading"></i> 正在加载更多数据...
            </div>
          </div> -->
          
          <!-- 搜索定位区域 - 移到筛选表下方 -->
          <div style="margin-top: 15px; padding: 15px; background-color: #f5f7fa; border-radius: 4px;">
            <div style="display: flex; flex-wrap: wrap; gap: 10px; align-items: center;">
              <!-- 目标表格选择 -->
              <div style="display: flex; align-items: center; gap: 5px;">
                <label style="white-space: nowrap; font-weight: bold;">搜索目标：</label>
                <select v-model="searchTargetTable" style="padding: 5px 10px; border: 1px solid #dcdfe6; border-radius: 4px; min-width: 100px;">
                  <option value="filtered">筛选表</option>
                  <option value="wish">志愿表</option>
                </select>
              </div>
              
              <!-- 学校名称搜索 -->
              <div style="position: relative; flex-grow: 1; min-width: 150px;">
                <input v-model="searchSchool" type="text" placeholder="请输入学校名称搜索定位" 
                       style="padding: 5px 30px 5px 10px; width: 100%; border: 1px solid #dcdfe6; border-radius: 4px;">
                <span v-if="searchSchool" 
                      @click="searchSchool = ''" 
                      style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%); cursor: pointer; color: #909399;">
                    ×
                  </span>
              </div>
              
              <!-- 专业名称搜索 -->
              <div style="position: relative; flex-grow: 1; min-width: 150px;">
                <input v-model="searchMajor" type="text" placeholder="请输入专业名称搜索定位" 
                       style="padding: 5px 30px 5px 10px; width: 100%; border: 1px solid #dcdfe6; border-radius: 4px;">
                <span v-if="searchMajor" 
                      @click="searchMajor = ''" 
                      style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%); cursor: pointer; color: #909399;">
                    ×
                  </span>
              </div>
              
              <!-- 定位按钮 -->
              <button type="button" class="remove-btn" @click="handleLocateSchool" 
                      style="width: auto; padding: 5px 15px; white-space: nowrap;">定位学校名称或专业</button>                
            </div>
          </div>
              

              <!-- 在现有的志愿表按钮区域添加自动排序按钮 -->
              <div id="wish-table" class="button-group">
                <button class="wish-button" @click="moveItemUp">↑选中项上移</button>
                <button class="wish-button" @click="moveItemDown">↓选中项下移</button>
                <button class="wish-button" @click="deleteSelectedItem">删除选中项</button>
                <button class="wish-button" @click="clearWishList">清空志愿表</button>
              </div> 
                <!-- 添加自动排序按钮 -->
              <div class="wishlist-action-buttons" style="display: flex; flex-wrap: wrap; gap: 10px;">
                <button class="custom-sort-button" style="flex: 1; min-width: 120px;" @click="showSortDialog = true">自动排序</button>
                <button v-if="hasSvipPermission" class="wish-button vip-badge-svip" style="flex: 1; min-width: 120px; position: relative;" @click="handleExportExcel">志愿表导出Excel<span class="feature-badge">规划师</span></button>
                <button v-if="hasSvipPermission" class="wish-button vip-badge-svip" style="flex: 1; min-width: 120px; position: relative;" @click="handleImportWishList">导入志愿表<span class="feature-badge">规划师</span></button>
                <button class="wish-button vip-badge-vip" style="flex: 1; min-width: 120px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); position: relative;" @click="openSaveWishlistDialog">💾 保存我的志愿<span class="feature-badge">VIP</span></button>
                <button class="wish-button vip-badge-vip" style="flex: 1; min-width: 120px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); position: relative;" @click="openWishlistHistory">📋 我的志愿记录<span class="feature-badge">VIP</span></button>
                <button class="add-btn" style="flex: 1; min-width: 120px;" @click="scrollTo('filter-table')">移动到筛选表</button>
              </div>
              <h3 style="margin: 15px 0; text-align: center; color: #409EFF; 
                  font-weight: bold; text-shadow: 
                  1px 1px 2px rgba(0,0,0,0.1);">志愿表</h3>
              <div style="display: flex; justify-content: center; margin-bottom: 12px;">
                <button v-if="wishHasActiveColumnFilters" type="button"
                  class="column-filter-btn"
                  @click="clearAllWishColumnFilters">
                  清空列筛选
                </button>
              </div>
              <!-- 找到志愿表的el-table-column部分并添加与筛选表相同的列宽设置 -->
              <el-table
                ref="wishTable"
                :data="columnFilteredWishData"
                :key="'wish-table-' + wishList.length"
                class="custom-table wishtable"
                border
                :style="{width: tableWidthSettings.overallWidth || '100%'}"
                height="500px"
                v-loading="isLoading"
                element-loading-spinner="el-icon-loading"
                highlight-current-row
                @row-click="selectItem"
                @row-contextmenu="handleRightClick"
                @row-dblclick="showFullContent"
                @cell-mouse-enter="showHoverTooltip"
                @cell-mouse-leave="hideHoverTooltip"
                @cell-click="showContentOnSmallScreen"
                @header-dragend="onColumnResizeEnd"
                header-cell-class-name="blue-header"
                :row-class-name="getRowClassName"
                :cell-class-name="getCellClassName"
                :row-height="36"
                :virtual-scroll="true"
                :buffer-size="10">


                <el-table-column
                  v-for="key in wishListColumns"
                  :key="key"
                  :prop="key"
                  :label="formatColumnName(key)"
                  :width="getColumnWidth(formatColumnName(key))"
                  header-align="center"
                  align="center"
                  resizable>
                  <template #header>
                    <el-popover
                      :ref="'wishFilterPopover_' + key"
                      v-model="wishShowColumnFilter[key]"
                      placement="bottom"
                      :width="280"
                      trigger="click"
                      popper-class="column-filter-popover">
                      <div class="column-filter-popover-content">
                        <el-input
                          v-model="wishColumnFilterSearchText[key]"
                          placeholder="搜索选项..."
                          size="mini"
                          prefix-icon="el-icon-search"
                          clearable
                          style="margin-bottom: 6px;">
                        </el-input>
                        <div class="filter-option-list">
                          <label class="filter-option-item select-all">
                            <input type="checkbox"
                              :checked="isAllWishFilterSelected(key)"
                              @change="toggleSelectAllWishFilter(key, $event.target.checked)">
                            <span class="filter-option-text">全选 ({{ getWishColumnUniqueOptions(key).length }})</span>
                          </label>
                          <label class="filter-option-item" v-for="opt in getWishFilteredOptions(key)" :key="opt">
                            <input type="checkbox"
                              :checked="isWishFilterOptionSelected(key, opt)"
                              @change="toggleWishFilterOption(key, opt)">
                            <span class="filter-option-text">{{ opt || '(空)' }}</span>
                          </label>
                        </div>
                        <div class="filter-option-count">
                          已选 {{ (wishColumnFilterValues[key] || []).length }} 项
                        </div>
                        <div class="column-filter-actions">
                          <el-button size="mini" type="primary" @click="applyWishColumnFilter(key)">确定</el-button>
                          <el-button size="mini" @click="clearWishColumnFilter(key)">清除</el-button>
                        </div>
                      </div>
                      <div
                        slot="reference"
                        class="column-filter-header"
                        :class="{ 'filter-active': wishColumnFilterValues[key] && wishColumnFilterValues[key].length }"
                        :title="(wishColumnFilterValues[key] && wishColumnFilterValues[key].length) ? '已选' + wishColumnFilterValues[key].length + '项' : '点击筛选此列'">
                        <span class="column-filter-label">{{ formatColumnName(key) }}</span>
                        <i v-if="wishColumnFilterValues[key] && wishColumnFilterValues[key].length" class="el-icon-s-operation column-filter-badge"></i>
                      </div>
                    </el-popover>
                  </template>
                  <!-- 最低位次：悬停显示位次趋势折线图（含最高位次）+ 招生数图 -->
                  <template v-if="key === 'l_rnk'" #default="{ row }">
                    <el-popover
                      v-if="row.rank_trend"
                      trigger="hover"
                      placement="right"
                      :width="220"
                      popper-class="rank-trend-popover"
                      :open-delay="200"
                    >
                      <div class="trend-popover-inner">
                        <!-- 位次趋势图 -->
                        <div class="trend-chart-title">位次趋势</div>
                        <svg :width="200" :height="50" class="trend-chart-svg">
                          <!-- l_rnk 趋势线（蓝色） -->
                          <polyline
                            :points="getTrendLinePath(row.rank_trend, 'l_rnk')"
                            fill="none"
                            stroke="#409EFF"
                            stroke-width="2"
                            stroke-linejoin="round"
                          />
                          <!-- l_rnk 数据点 -->
                          <circle
                            v-for="(dot, di) in getTrendDots(row.rank_trend, 'l_rnk')"
                            :key="'l'+di"
                            :cx="dot.x"
                            :cy="dot.y"
                            r="3"
                            fill="#409EFF"
                            stroke="#fff"
                            stroke-width="1"
                          >
                            <title>{{ dot.year }}年 最低位次 {{ dot.rank }}名</title>
                          </circle>
                          <!-- h_rnk 趋势线（红色） -->
                          <polyline
                            :points="getTrendLinePath(row.rank_trend, 'h_rnk')"
                            fill="none"
                            stroke="#F56C6C"
                            stroke-width="2"
                            stroke-linejoin="round"
                          />
                          <!-- h_rnk 数据点 -->
                          <circle
                            v-for="(dot, di) in getTrendDots(row.rank_trend, 'h_rnk')"
                            :key="'h'+di"
                            :cx="dot.x"
                            :cy="dot.y"
                            r="3"
                            fill="#F56C6C"
                            stroke="#fff"
                            stroke-width="1"
                          >
                            <title>{{ dot.year }}年 最高位次 {{ dot.rank }}名</title>
                          </circle>
                          <!-- 用户位次虚线 -->
                          <line
                            v-if="formData.admission_rank"
                            :x1="14" :y1="getUserRankY(row.rank_trend)"
                            :x2="186" :y2="getUserRankY(row.rank_trend)"
                            stroke="#E6A23C"
                            stroke-width="1.5"
                            stroke-dasharray="5,3"
                          />
                        </svg>
                        <div class="trend-legend">
                          <span class="trend-legend-item">
                            <span class="trend-legend-line lrnk-line"></span>最低
                          </span>
                          <span class="trend-legend-item">
                            <span class="trend-legend-line hrnk-line"></span>最高
                          </span>
                          <span v-if="formData.admission_rank" class="trend-legend-item">
                            <span class="trend-legend-line myrnk-line"></span>我的{{ formData.admission_rank }}
                          </span>
                        </div>
                        <!-- 招生数图 -->
                        <div class="trend-chart-title">招生数</div>
                        <svg :width="200" :height="50" class="trend-chart-svg">
                          <!-- 计划数（plan）虚线 -->
                          <polyline
                            :points="getEnrollmentLinePath(row.rank_trend, 'plan')"
                            fill="none"
                            stroke="#67C23A"
                            stroke-width="2"
                            stroke-linejoin="round"
                            stroke-dasharray="5,3"
                          />
                          <!-- 往年数（pre_pl）实线 -->
                          <polyline
                            :points="getEnrollmentLinePath(row.rank_trend, 'pre_pl')"
                            fill="none"
                            stroke="#909399"
                            stroke-width="2"
                            stroke-linejoin="round"
                          />
                          <!-- plan 数据点 -->
                          <circle
                            v-for="(dot, di) in getEnrollmentDots(row.rank_trend, 'plan')"
                            :key="'p'+di"
                            :cx="dot.x" :cy="dot.y" r="2.5"
                            fill="#67C23A" stroke="#fff" stroke-width="0.5"
                          >
                            <title>{{ dot.year }}年 计划数 {{ dot.val }}人</title>
                          </circle>
                          <!-- pre_pl 数据点 -->
                          <circle
                            v-for="(dot, di) in getEnrollmentDots(row.rank_trend, 'pre_pl')"
                            :key="'pp'+di"
                            :cx="dot.x" :cy="dot.y" r="2.5"
                            fill="#909399" stroke="#fff" stroke-width="0.5"
                          >
                            <title>{{ dot.year }}年 往年数 {{ dot.val }}人</title>
                          </circle>
                        </svg>
                        <div class="trend-legend">
                          <span class="trend-legend-item">
                            <span class="trend-legend-line plan-line"></span>计划数
                          </span>
                          <span class="trend-legend-item">
                            <span class="trend-legend-line prepl-line"></span>往年数
                          </span>
                        </div>
                        <!-- 逐年数据表 -->
                        <div class="trend-years-data">
                          <div v-for="d in parseTrendData(row.rank_trend)" :key="d.year" class="trend-year-row">
                            <span class="trend-year">{{ d.year }}年</span>
                            <span class="trend-lrnk">{{ d.l_rnk != null ? d.l_rnk : '--' }}</span>
                            <span class="trend-ecnt">{{ d.plan != null ? d.plan : '--' }}</span>
                            <span class="trend-ecnt-pre">{{ d.pre_pl != null ? d.pre_pl : '--' }}</span>
                          </div>
                        </div>
                      </div>
                      <span slot="reference" class="rank-value-hoverable">{{ row[key] }}</span>
                    </el-popover>
                    <span v-else>{{ row[key] }}</span>
                  </template>
                  <!-- 专业名称：悬停显示考研方向 -->
                  <template v-else-if="key === 'major_name'" #default="{ row }">
                    <el-popover
                      trigger="hover"
                      placement="top"
                      :open-delay="200"
                      :disabled="!row.grad_dir && !row.main_sub && !row.job_dir"
                      popper-class="major-graddir-popover"
                    >
                      <div v-if="row.main_sub" class="graddir-label">专业课程</div>
                      <div v-if="row.main_sub" class="graddir-content">{{ row.main_sub }}</div>
                      <div v-if="row.main_sub && row.grad_dir" class="graddir-divider"></div>
                      <div v-if="row.grad_dir" class="graddir-label">考研方向</div>
                      <div v-if="row.grad_dir" class="graddir-content">{{ row.grad_dir }}</div>
                      <div v-if="(row.grad_dir || row.main_sub) && row.job_dir" class="graddir-divider"></div>
                      <div v-if="row.job_dir" class="graddir-label">就业方向</div>
                      <div v-if="row.job_dir" class="graddir-content">{{ row.job_dir }}</div>
                      <span slot="reference" class="maj-name-cell" :class="{ 'maj-name-hoverable': row.grad_dir || row.main_sub || row.job_dir }">{{ row[key] }}</span>
                    </el-popover>
                  </template>
                </el-table-column>
              </el-table>
            <!-- </div> -->
        </div>
    </div>
    <footer class="footer" style="text-align: center; 
    padding: 20px 0; background-color: #f5f5f5; 
    margin-top: 20px; color: #888;">
      <div class="footer-content">
        <p style="margin: 5px 0;">版权所有 © {{ currentYear }} 愿毕达所有</p>
        <p style="margin: 5px 0;">数据仅供参考，以官方公布为准</p>
      </div>
    </footer>


    <!-- 自动排序弹窗 -->
    <el-dialog
      title="自动排序 — 选择排序方式"
      :visible.sync="showSortDialog"
      width="520px"
      :close-on-click-modal="false"
      top="28vh"
      custom-class="sort-dialog">
      <div class="sort-body">
        <el-radio-group v-model="wishSortMode" class="sort-compare">
          <el-radio :label="'maxRank'" class="sort-col">
            <div class="sort-col-inner">
              <div class="sort-col-header">
                <span class="sort-col-badge">A</span>
                <span class="sort-col-name">当前数据排序</span>
              </div>
            </div>
          </el-radio>
          <el-radio :label="'minScoreRank'" class="sort-col">
            <div class="sort-col-inner">
              <div class="sort-col-header">
                <span class="sort-col-badge">B</span>
                <span class="sort-col-name">组内最低位次排序</span>
              </div>
            </div>
          </el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSortDialog = false">取消</el-button>
        <el-button type="primary" @click="showSortDialog = false; autoSortWishList()">开始排序</el-button>
      </span>
    </el-dialog>

    <!-- 导入志愿表弹窗 - 全屏 -->
    <el-dialog
      title="导入志愿表"
      :visible.sync="showImportDialog"
      :fullscreen="true"
      :close-on-click-modal="false"
      custom-class="import-dialog-fullscreen">
      <div
        class="import-drop-zone-fullscreen"
        @dragover="handleDragOver"
        @dragleave="handleDragLeave"
        @drop="handleDrop"
        @click="$refs.fileInput.click()">
        <i class="el-icon-upload" style="font-size: 120px; color: #409EFF;"></i>
        <p style="margin-top: 40px; font-size: 24px; color: #606266;">
          将Excel文件拖拽到此处，或点击选择文件
        </p>
        <p style="margin-top: 20px; font-size: 18px; color: #909399;">
          支持 .xlsx、.xls 格式文件
        </p>
        <input
          ref="fileInput"
          type="file"
          accept=".xlsx,.xls"
          style="display: none"
          @change="handleFileSelect">
      </div>
      <div style="margin-top: 40px; display: flex; align-items: center; justify-content: center; gap: 40px;">
        <el-radio-group v-model="importMode" size="large">
          <el-radio label="append">添加到志愿表</el-radio>
          <el-radio label="overwrite">覆盖志愿表</el-radio>
        </el-radio-group>
      </div>
      <!-- 关闭按钮 -->
      <div style="margin-top: 40px; display: flex; justify-content: center;">
        <button class="wish-button" style="padding: 12px 40px; font-size: 16px;" @click="showImportDialog = false">关闭</button>
      </div>
    </el-dialog>

    <!-- 问题反馈弹窗 -->
    <div v-if="showFeedbackModal" class="modal-overlay" @click.self="closeFeedbackModal">
      <div class="feedback-modal-container">
        <div class="modal-header" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
          <h3 style="margin: 0;">问题反馈</h3>
          <button class="close-btn" @click="closeFeedbackModal" style="background: none; border: none; font-size: 24px; cursor: pointer; color: #999;">×</button>
        </div>
        <p class="modal-desc">请描述您遇到的问题或建议，我们会尽快处理</p>
        <div class="feedback-form">
          <div class="feedback-form-item">
            <label class="feedback-label">反馈内容 <span class="required">*</span></label>
            <textarea 
              v-model="feedbackContent" 
              placeholder="请详细描述您遇到的问题..." 
              class="feedback-textarea"
              rows="4"></textarea>
          </div>
          <!-- 图片上传区域 -->
          <div class="feedback-form-item">
            <label class="feedback-label">截图<span class="optional">（选填，支持粘贴图片）</span></label>
            <div class="image-upload-wrapper">
              <div
                class="image-upload-area"
                @paste="handleFeedbackPaste"
                tabindex="0"
                ref="feedbackImageArea"
              >
                <div v-if="feedbackImages.length === 0" class="upload-placeholder">
                  <p>点击此处后按 Ctrl+V 粘贴截图</p>
                  <p style="font-size: 12px; color: #999;">或直接将图片粘贴到此处</p>
                </div>
                <div v-else class="image-preview-list">
                  <div v-for="(img, index) in feedbackImages" :key="index" class="image-preview-item">
                    <img :src="img" alt="反馈图片" @click="previewFeedbackImage(img)">
                    <button type="button" class="remove-image-btn" @click="removeFeedbackImage(index)">×</button>
                  </div>
                  <div v-if="feedbackImages.length < 5" class="add-more-images" @click="focusImageArea">
                    <span>+</span>
                    <p>继续粘贴</p>
                  </div>
                </div>
              </div>
              <input
                type="file"
                ref="feedbackFileInput"
                accept="image/*"
                multiple
                style="display: none;"
                @change="handleFeedbackFileSelect"
              />
              <button type="button" class="upload-image-btn" @click="triggerFeedbackFileInput">
                <span>📁</span>
                <span>上传图片</span>
              </button>
            </div>
            <p v-if="feedbackImages.length > 0" class="image-count-hint">
              已添加 {{ feedbackImages.length }} 张图片，最多5张
            </p>
          </div>
          <div class="feedback-form-item">
            <label class="feedback-label">联系方式<span class="optional">（选填）</span></label>
            <input 
              type="text" 
              v-model="feedbackContact" 
              placeholder="手机号/邮箱/微信，方便我们联系您" 
              class="feedback-input">
          </div>
        </div>
        <div class="feedback-modal-buttons">
          <button type="button" class="feedback-btn-cancel" @click="closeFeedbackModal">取消</button>
          <button type="button" class="feedback-btn-confirm" @click="submitFeedback" :disabled="isSubmittingFeedback">
            {{ isSubmittingFeedback ? '提交中...' : '提交反馈' }}
          </button>
        </div>
      </div>
    </div>
    
    <!-- 消息通知弹窗 -->
    <div v-if="showMessageModal" class="modal-overlay" @click.self="closeMessageModal">
      <div class="message-modal-container">
        <div class="modal-header" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
          <h3>消息通知</h3>
          <button class="close-btn" @click="closeMessageModal" style="background: none; border: none; font-size: 20px; cursor: pointer;">×</button>
        </div>
        
        <!-- 消息列表 -->
        <div class="message-list" style="max-height: 60vh; overflow-y: auto;">
          <div v-if="messageList.length === 0" class="no-message" style="text-align: center; color: #999; padding: 40px;">
            暂无消息
          </div>
          
          <div v-for="msg in messageList" :key="msg.id" 
               class="message-item" 
               :class="{ unread: !msg.is_read }"
               style="padding: 15px; border-bottom: 1px solid #eee; cursor: pointer;"
               @click="readMessage(msg)">
            <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
              <span style="font-weight: bold; color: #333;">{{ msg.title }}</span>
              <span style="color: #999; font-size: 12px;">{{ msg.created_at }}</span>
            </div>
            <div style="color: #666; font-size: 14px; line-height: 1.5; white-space: pre-wrap;">{{ msg.content }}</div>
            <div v-if="!msg.is_read" style="margin-top: 5px;">
              <span style="color: #f44336; font-size: 12px;">未读</span>
            </div>
          </div>
        </div>
        
        <!-- 操作按钮 -->
        <div class="modal-buttons" style="margin-top: 15px; display: flex; justify-content: space-between;">
          <button type="button" class="btn-cancel" @click="closeMessageModal">关闭</button>
          <button v-if="unreadMessageCount > 0" type="button" class="btn-confirm" @click="markAllMessagesRead">全部已读</button>
        </div>
      </div>
    </div>
    
    <!-- 图片预览弹窗 -->
    <div v-if="previewImageUrl" class="modal-overlay" @click.self="previewImageUrl = null">
      <div class="modal-container" style="max-width: 90vw; max-height: 90vh; padding: 10px;">
        <img :src="previewImageUrl" style="max-width: 100%; max-height: 85vh; display: block; margin: 0 auto;">
        <div class="modal-buttons" style="margin-top: 10px;">
          <button type="button" class="btn-cancel" @click="previewImageUrl = null">关闭</button>
        </div>
      </div>
    </div>

    <!-- 专业关联弹窗 -->
    <div v-if="showMajorMappingDialog" class="modal-overlay">
      <div ref="majorMappingModalContent" class="modal" style="width: 90%; max-width: 1200px; max-height: 90vh; overflow-y: auto;">
        <div class="modal-header">
          <h3>连续相同专业数据 - 手动关联</h3>
          <button class="close-btn" @click="showMajorMappingDialog = false">×</button>
        </div>
        <!-- 加载进度条 -->
        <div v-if="majorMappingLoadingStatus" style="padding: 10px 20px; background: #f0f9eb; border-bottom: 1px solid #e0e0e0;">
          <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 5px;">
            <span style="font-size: 13px; color: #67c23a;">{{ majorMappingLoadingStatus }}</span>
            <span v-if="majorMappingLoadingProgress > 0" style="font-size: 13px; color: #67c23a; font-weight: bold;">{{ majorMappingLoadingProgress }}%</span>
          </div>
          <div style="width: 100%; height: 6px; background-color: #e4e7ed; border-radius: 3px; overflow: hidden;">
            <div :style="{ width: majorMappingLoadingProgress + '%', height: '100%', backgroundColor: '#67c23a', transition: 'width 0.3s ease' }"></div>
          </div>
        </div>
        <div class="modal-body" style="padding: 10px; color: #909399; font-size: 13px;">
          <span v-if="autoMatchSummary.total > 0" style="color: #67c23a;">
            自动确认：{{ autoMatchSummary.confirmed }}组，需要复核：{{ autoMatchSummary.review }}组
          </span>
          <span v-else>加载中...</span>
        </div>
        <!-- 筛选条件区域 - 固定定位 -->
        <div class="modal-body" style="padding: 10px 20px; background: #f5f7fa; border-bottom: 1px solid #e0e0e0; position: sticky; top: 0; z-index: 100;">
          <div style="display: flex; gap: 15px; flex-wrap: wrap; align-items: center;">
            <span style="font-weight: bold; color: #606266;">筛选条件:</span>
            <!-- 批次筛选 -->
            <div style="display: flex; align-items: center; gap: 5px;">
              <label style="color: #606266; font-size: 13px;">批次:</label>
              <select v-model="majorMappingFilters.batch" 
                      @change="handleMajorMappingFilterChange"
                      style="padding: 4px 8px; border: 1px solid #dcdfe6; border-radius: 4px; font-size: 13px; min-width: 100px;">
                <option value="">全部</option>
                <option value="本科提前批">本科提前批</option>
                <option value="本科批">本科批</option>
                <option value="专科提前批">专科提前批</option>
                <option value="专科批">专科批</option>
              </select>
            </div>
            <!-- 重置筛选按钮 -->
            <button type="button" 
                    @click="resetMajorMappingFilters"
                    style="padding: 4px 12px; background: #909399; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 12px;">
              重置筛选
            </button>
            <!-- 定位未确认按钮 -->
            <button type="button" 
                    @click="locateNextUnconfirmedGroup"
                    style="padding: 4px 12px; background: #e6a23c; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 12px; margin-left: 8px;">
              定位未确认
            </button>
            <!-- 定位备注不全按钮 -->
            <button type="button" 
                    @click="locateFirstIncompletePlanRemarkGroup"
                    style="padding: 4px 12px; background: #f56c6c; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 12px; margin-left: 8px;">
              定位备注不全
            </button>
            <!-- 显示筛选结果数量 -->
            <span style="color: #0482ff; font-size: 13px; margin-left: auto;">
              共 {{ filteredMajorGroups.length }} 组
            </span>
          </div>
        </div>
        <!-- 顶部分页组件 - 固定定位 -->
        <div v-if="filteredMajorGroups.length > 0" style="padding: 10px 20px; background: #f5f7fa; border-bottom: 1px solid #e0e0e0; text-align: center; position: sticky; top: 52px; z-index: 99;">
          <button type="button" 
                  :disabled="majorMappingCurrentPage === 1" 
                  @click="goToMajorMappingPage(1)"
                  style="padding: 4px 8px; margin: 0 2px; cursor: pointer; font-size: 12px;">首页</button>
          <button type="button" 
                  :disabled="majorMappingCurrentPage === 1" 
                  @click="goToMajorMappingPage(majorMappingCurrentPage - 1)"
                  style="padding: 4px 8px; margin: 0 2px; cursor: pointer; font-size: 12px;">上一页</button>
          <span style="margin: 0 8px; font-size: 13px;">第 {{ majorMappingCurrentPage }} / {{ majorMappingFilteredTotalPages }} 页</span>
          <button type="button" 
                  :disabled="majorMappingCurrentPage === majorMappingFilteredTotalPages" 
                  @click="goToMajorMappingPage(majorMappingCurrentPage + 1)"
                  style="padding: 4px 8px; margin: 0 2px; cursor: pointer; font-size: 12px;">下一页</button>
          <button type="button" 
                  :disabled="majorMappingCurrentPage === majorMappingFilteredTotalPages" 
                  @click="goToMajorMappingPage(majorMappingFilteredTotalPages)"
                  style="padding: 4px 8px; margin: 0 2px; cursor: pointer; font-size: 12px;">末页</button>
          <select v-model="majorMappingPageSize" @change="majorMappingCurrentPage = 1; scrollToMajorMappingTop()" style="margin-left: 8px; padding: 4px; font-size: 12px;">
            <option :value="5">5组/页</option>
            <option :value="10">10组/页</option>
            <option :value="20">20组/页</option>
            <option :value="50">50组/页</option>
            <option :value="100">100组/页</option>
          </select>
        </div>
        <div class="modal-body" style="padding-top: 15px;">
          <div v-if="filteredMajorGroups.length === 0 && !majorMappingLoadingStatus" style="text-align: center; padding: 40px; color: #999;">
            暂无符合条件的连续相同专业数据
          </div>
          <div v-else-if="filteredMajorGroups.length === 0 && majorMappingLoadingStatus" style="text-align: center; padding: 40px; color: #67c23a;">
            <div style="font-size: 16px; margin-bottom: 10px;">⏳ 正在加载数据，请稍候...</div>
            <div style="font-size: 13px;">{{ majorMappingLoadingStatus }}</div>
          </div>
          <div v-else>
            <div v-for="(group, groupIndex) in paginatedFilteredMajorGroups" :key="groupIndex" 
                 :ref="'majorGroup_' + ((majorMappingCurrentPage - 1) * majorMappingPageSize + groupIndex)"
                 :data-group-index="((majorMappingCurrentPage - 1) * majorMappingPageSize + groupIndex)"
                 style="margin-bottom: 20px; border: 1px solid #e0e0e0; border-radius: 8px; overflow: hidden;">
              <div style="background: #f5f7fa; padding: 12px 15px; border-bottom: 1px solid #e0e0e0;">
                <!-- 第一行：学校专业信息和主要操作 -->
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
                  <div>
                    <strong>{{ group.school_name }} - {{ group.major_name }}</strong>
                    <span style="margin-left: 10px; color: #909399;">共 {{ group.records.length }} 条记录</span>
                    <button v-if="group._incompletePlanRemark && !group._manualConfirmedComplete" 
                          type="button"
                          @click="confirmIncompletePlanRemark(group)"
                          style="margin-left: 10px; padding: 2px 8px; background: #f56c6c; color: white; border: none; border-radius: 4px; font-size: 11px; cursor: pointer;">
                      确认备注全
                    </button>
                    <span v-if="group.records.some(r => r._isAutoMatched && !r.in_mapping)" 
                          style="margin-left: 10px; padding: 2px 8px; background: #67c23a; color: white; border-radius: 4px; font-size: 11px;">
                      自动
                    </span>
                  </div>
                  <button type="button" 
                          @click="addSelectionToGroupSort(group)"
                          style="padding: 4px 12px; background: #67C23A; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 12px;">
                    添加选中到排序
                  </button>
                </div>
                <!-- 第二行：快捷按钮组 -->
                <div style="display: flex; gap: 8px; flex-wrap: wrap; align-items: center;">
                  <span style="color: #606266; font-size: 12px; margin-right: 5px;">快捷操作:</span>
                  <!-- 招生计划备注下拉选择 -->
                  <select v-model="group.selectedPlanRemark"
                          @change="handlePlanRemarkSelect(group)"
                          style="padding: 3px 8px; border: 1px solid #0482ff; border-radius: 4px; font-size: 12px; min-width: 150px; max-width: 300px; color: #0482ff;">
                    <option value="">选择招生备注</option>
                    <option v-for="(item, index) in getUniquePlanRemarks(group)" 
                            :key="index" 
                            :value="item.remark">
                      {{ item.admit_year }} {{ item.remark }}
                    </option>
                  </select>
                  <button type="button" 
                          @click="fillPlanRemarkToGroup(group)"
                          :disabled="!group.selectedPlanRemark"
                          title="将选中的招生备注应用到该组所有记录"
                          style="padding: 3px 10px; background: #0482ff; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 12px;">
                    应用招生备注
                  </button>
                  <button type="button" 
                          @click="confirmGroupAll(group)"
                          title="勾选该组所有确认框"
                          style="padding: 3px 10px; background: #E6A23C; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 12px;">
                    全选确认
                  </button>
                  <button type="button" 
                          @click="cancelGroupAll(group)"
                          title="取消该组所有确认框"
                          style="padding: 3px 10px; background: #F56C6C; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 12px;">
                    取消全选
                  </button>
                  <button type="button" 
                          @click="resetGroup(group)"
                          title="重置该组所有数据（取消确认框）"
                          style="padding: 3px 10px; background: #DC143C; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 12px; font-weight: bold;">
                    重置本组
                  </button>
                </div>
              </div>
              <table class="mapping-table" style="width: 100%; border-collapse: collapse; background: white;">
                <thead>
                  <tr style="background: #fafafa;">
                    <th style="padding: 8px; border-bottom: 1px solid #e0e0e0; text-align: left;">年份</th>
                    <th style="padding: 8px; border-bottom: 1px solid #e0e0e0; text-align: left;">批次</th>
                    <th style="padding: 8px; border-bottom: 1px solid #e0e0e0; text-align: left;">科类</th>
                    <th style="padding: 8px; border-bottom: 1px solid #e0e0e0; text-align: left;">专业组</th>
                    <th style="padding: 8px; border-bottom: 1px solid #e0e0e0; text-align: left;">专业备注</th>
                    <th style="padding: 8px; border-bottom: 1px solid #e0e0e0; text-align: left;">招生计划备注</th>
                    <th style="padding: 8px; border-bottom: 1px solid #e0e0e0; text-align: center;">
                      确认
                      <input type="checkbox" 
                             :checked="isGroupAllSelected(group)" 
                             @change="toggleGroupSelection(group)"
                             style="margin-left: 5px;"
                             title="全选/取消">
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(record, recordIndex) in group.records">
                    <!-- 如果有多个招生计划备注，展开成多行 -->
                    <template v-if="record.plan_remark_list && record.plan_remark_list.length > 1">
                      <tr v-for="(item, itemIdx) in record.plan_remark_list" 
                          :key="recordIndex + '_' + itemIdx"
                          :ref="recordIndex === 0 && itemIdx === 0 ? 'groupFirstRow_' + ((majorMappingCurrentPage - 1) * majorMappingPageSize + groupIndex) : null"
                          :style="{ 
                            backgroundColor: record.selected_plan_items && record.selected_plan_items.some(selected => selected.admit_year === item.admit_year && selected.batch === item.batch && selected.remark === item.remark) 
                              ? '#f0f9eb' 
                              : '' 
                          }">
                        <td style="padding: 8px; border-bottom: 1px solid #e0e0e0;">{{ record.admit_year }}</td>
                        <td style="padding: 8px; border-bottom: 1px solid #e0e0e0;">{{ record.batch }}</td>
                        <td style="padding: 8px; border-bottom: 1px solid #e0e0e0;">{{ record.subject }}</td>
                        <td style="padding: 8px; border-bottom: 1px solid #e0e0e0;">{{ record.major_group }}</td>
                        <td style="padding: 8px; border-bottom: 1px solid #e0e0e0;">{{ record.remark }}</td>
                        <td style="padding: 8px; border-bottom: 1px solid #e0e0e0; color: #409EFF;">
                          <span style="font-size: 12px;">
                            <span style="color: #909399;">{{ item.admit_year }}:</span> 
                            <span v-if="item.remark">{{ item.remark }}</span>
                            <span v-else style="color: #909399;">(无备注)</span>
                          </span>
                        </td>
                        <td style="padding: 8px; border-bottom: 1px solid #e0e0e0; text-align: center;">
                          <input type="checkbox" 
                                 :checked="record.selected_plan_items && record.selected_plan_items.some(selected => selected.admit_year === item.admit_year && selected.batch === item.batch && selected.remark === item.remark)"
                                 @change="selectPlanRemarkItem(record, item)">
                        </td>
                      </tr>
                    </template>
                    <!-- 只有一个或没有招生计划备注，正常显示 -->
                    <tr v-else :key="recordIndex"
                        :ref="recordIndex === 0 ? 'groupFirstRow_' + ((majorMappingCurrentPage - 1) * majorMappingPageSize + groupIndex) : null">
                      <td style="padding: 8px; border-bottom: 1px solid #e0e0e0;">{{ record.admit_year }}</td>
                      <td style="padding: 8px; border-bottom: 1px solid #e0e0e0;">{{ record.batch }}</td>
                      <td style="padding: 8px; border-bottom: 1px solid #e0e0e0;">{{ record.subject }}</td>
                      <td style="padding: 8px; border-bottom: 1px solid #e0e0e0;">{{ record.major_group }}</td>
                      <td style="padding: 8px; border-bottom: 1px solid #e0e0e0;">{{ record.remark }}</td>
                      <td style="padding: 8px; border-bottom: 1px solid #e0e0e0; color: #409EFF;">
                        <span v-if="record.plan_remark">{{ record.plan_remark }}</span>
                        <span v-else style="color: #909399;">无</span>
                      </td>
                      <td style="padding: 8px; border-bottom: 1px solid #e0e0e0; text-align: center;">
                        <input type="checkbox" v-model="record.is_confirmed">
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- 分页组件 -->
        <div v-if="filteredMajorGroups.length > 0" style="padding: 15px; border-top: 1px solid #e0e0e0; text-align: center;">
          <span style="margin-right: 15px;">共 {{ filteredMajorGroups.length }} 组</span>
          <button type="button" 
                  :disabled="majorMappingCurrentPage === 1" 
                  @click="goToMajorMappingPage(1)"
                  style="padding: 5px 10px; margin: 0 3px; cursor: pointer;">首页</button>
          <button type="button" 
                  :disabled="majorMappingCurrentPage === 1" 
                  @click="goToMajorMappingPage(majorMappingCurrentPage - 1)"
                  style="padding: 5px 10px; margin: 0 3px; cursor: pointer;">上一页</button>
          <span style="margin: 0 10px;">第 {{ majorMappingCurrentPage }} / {{ majorMappingFilteredTotalPages }} 页</span>
          <button type="button" 
                  :disabled="majorMappingCurrentPage === majorMappingFilteredTotalPages" 
                  @click="goToMajorMappingPage(majorMappingCurrentPage + 1)"
                  style="padding: 5px 10px; margin: 0 3px; cursor: pointer;">下一页</button>
          <button type="button" 
                  :disabled="majorMappingCurrentPage === majorMappingFilteredTotalPages" 
                  @click="goToMajorMappingPage(majorMappingFilteredTotalPages)"
                  style="padding: 5px 10px; margin: 0 3px; cursor: pointer;">末页</button>
          <select v-model="majorMappingPageSize" @change="majorMappingCurrentPage = 1; scrollToMajorMappingTop()" style="margin-left: 10px; padding: 5px;">
            <option :value="5">5组/页</option>
            <option :value="10">10组/页</option>
            <option :value="20">20组/页</option>
            <option :value="50">50组/页</option>
            <option :value="100">100组/页</option>
          </select>
        </div>
        <div class="modal-footer" style="padding: 15px; text-align: right; border-top: 1px solid #e0e0e0;">
          <button type="button" class="btn btn-cancel" @click="showMajorMappingDialog = false" style="margin-right: 10px;">取消</button>
          <button type="button" class="btn btn-primary" @click="saveMajorMappings" style="margin-right: 10px;">保存本页关联</button>
          <button type="button" class="btn btn-success" @click="selectAllMajorMappingsConfirm">保存所有关联</button>
        </div>
      </div>
    </div>

    <!-- 保存志愿表弹窗 -->
    <div v-if="showSaveWishlistDialog" class="modal-overlay" @click.self="closeSaveWishlistDialog">
      <div class="modal" style="width: 90%; max-width: 600px; max-height: 90vh; overflow-y: auto;">
        <div class="modal-header">
          <h3>保存我的志愿</h3>
          <button class="close-btn" @click="closeSaveWishlistDialog">×</button>
        </div>
        <div class="modal-body">
          <div style="margin-bottom: 20px;">
            <label style="display: block; margin-bottom: 5px; font-weight: bold;">志愿表名称</label>
            <input v-model="wishlistForm.name" type="text" placeholder="请输入志愿表名称（可选）" 
                   style="width: 100%; padding: 8px; border: 1px solid #dcdfe6; border-radius: 4px;">
          </div>
          <div style="margin-bottom: 20px;">
            <label style="display: block; margin-bottom: 5px; font-weight: bold;">学生姓名</label>
            <input v-model="wishlistForm.student_name" type="text" placeholder="请输入学生姓名" 
                   style="width: 100%; padding: 8px; border: 1px solid #dcdfe6; border-radius: 4px;">
          </div>
          <div style="margin-bottom: 20px;">
            <label style="display: block; margin-bottom: 5px; font-weight: bold;">备注</label>
            <textarea v-model="wishlistForm.remark" placeholder="请输入备注信息（可选）" rows="3"
                      style="width: 100%; padding: 8px; border: 1px solid #dcdfe6; border-radius: 4px; resize: vertical;"></textarea>
          </div>
          <div style="background: #f5f7fa; padding: 15px; border-radius: 4px; margin-bottom: 20px;">
            <h4 style="margin: 0 0 10px 0; color: #409EFF;">志愿表概览</h4>
            <p style="margin: 5px 0;">共 {{ wishList.length }} 个志愿</p>
            <p style="margin: 5px 0;">冲: {{ wishList.filter(i => i.risk === '冲' || i.冲稳保 === '冲').length }} 个</p>
            <p style="margin: 5px 0;">稳: {{ wishList.filter(i => i.risk === '稳' || i.冲稳保 === '稳').length }} 个</p>
            <p style="margin: 5px 0;">保: {{ wishList.filter(i => i.risk === '保' || i.冲稳保 === '保').length }} 个</p>
          </div>
        </div>
        <div class="modal-footer" style="padding: 15px; text-align: right; border-top: 1px solid #e0e0e0;">
          <button type="button" class="btn btn-cancel" @click="closeSaveWishlistDialog" style="margin-right: 10px;">取消</button>
          <button type="button" class="btn btn-primary" @click="saveWishlist" :disabled="isSavingWishlist">
            {{ isSavingWishlist ? '保存中...' : '保存志愿表' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 志愿表历史记录弹窗（含分享功能） -->
    <div v-if="showWishlistHistoryDialog" class="modal-overlay" @click.self="closeWishlistHistoryDialog">
      <div class="modal" style="width: 95%; max-width: 1200px; max-height: 90vh; overflow-y: auto;">
        <div class="modal-header">
          <h3>志愿记录</h3>
          <button class="close-btn" @click="closeWishlistHistoryDialog">×</button>
        </div>
        <div class="modal-body">
          <!-- 选项卡导航 -->
          <div style="display: flex; border-bottom: 2px solid #e0e0e0; margin-bottom: 15px;">
            <div :class="{'tab-active': wishlistTab === 'my'}" style="padding: 10px 20px; cursor: pointer; border-bottom: 2px solid transparent; margin-bottom: -2px; font-weight: bold; color: #666;" @click="switchWishlistTab('my')">
              我的记录
              <span v-if="wishlistHistory.length > 0" style="margin-left: 4px; font-size: 12px; color: #409EFF;">({{ wishlistHistory.length }})</span>
            </div>
            <div :class="{'tab-active': wishlistTab === 'shared-to-me'}" style="padding: 10px 20px; cursor: pointer; border-bottom: 2px solid transparent; margin-bottom: -2px; font-weight: bold; color: #666;" @click="switchWishlistTab('shared-to-me')">
              分享给我的
              <span v-if="sharedWishlists.length > 0" style="margin-left: 4px; font-size: 12px; color: #E6A23C;">({{ sharedWishlists.length }})</span>
            </div>
          </div>

          <!-- ===== 我的记录 ===== -->
          <div v-if="wishlistTab === 'my'">
            <div v-if="wishlistHistory.length === 0" style="text-align: center; padding: 40px; color: #999;">
              暂无志愿记录
            </div>
            <div v-else>
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr style="background: #f5f7fa;">
                    <th style="padding: 12px; border-bottom: 1px solid #e0e0e0; text-align: left;">名称</th>
                    <th style="padding: 12px; border-bottom: 1px solid #e0e0e0; text-align: left;">学生</th>
                    <th style="padding: 12px; border-bottom: 1px solid #e0e0e0; text-align: left;">年份/科类/批次</th>
                    <th style="padding: 12px; border-bottom: 1px solid #e0e0e0; text-align: center;">分数/位次</th>
                    <th style="padding: 12px; border-bottom: 1px solid #e0e0e0; text-align: center;">志愿数</th>
                    <th style="padding: 12px; border-bottom: 1px solid #e0e0e0; text-align: center;">保存时间</th>
                    <th style="padding: 12px; border-bottom: 1px solid #e0e0e0; text-align: center;">操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in wishlistHistory" :key="item.id" style="border-bottom: 1px solid #e0e0e0;">
                    <td style="padding: 12px;">
                      <div v-if="item.name && item.name.indexOf('（') > -1">
                        <div>{{ item.name.substring(0, item.name.indexOf('（')) }}</div>
                        <div style="font-size: 11px; color: #909399;">{{ item.name.substring(item.name.indexOf('（')) }}</div>
                      </div>
                      <div v-else>{{ item.name || '未命名' }}</div>
                    </td>
                    <td style="padding: 12px;">{{ item.student_name || '-' }}</td>
                    <td style="padding: 12px;">{{ item.admit_year }} / {{ item.subject }} / {{ item.batch }}</td>
                    <td style="padding: 12px; text-align: center;">{{ item.score }} / {{ item.admission_rank }}</td>
                    <td style="padding: 12px; text-align: center;">{{ item.item_count }}</td>
                    <td style="padding: 12px; text-align: center;">{{ item.created_at }}</td>
                    <td style="padding: 12px; text-align: center;">
                      <button @click="viewWishlistDetail(item.id)" style="padding: 4px 12px; margin-right: 5px; background: #409EFF; color: white; border: none; border-radius: 4px; cursor: pointer;">查看</button>
                      <button @click="loadWishlistToTable(item.id)" style="padding: 4px 12px; margin-right: 5px; background: #67C23A; color: white; border: none; border-radius: 4px; cursor: pointer;">加载</button>
                      <button @click="openShareDialog(item)" style="padding: 4px 12px; margin-right: 5px; background: #E6A23C; color: white; border: none; border-radius: 4px; cursor: pointer;">分享</button>
                      <button @click="deleteWishlist(item.id)" style="padding: 4px 12px; background: #F56C6C; color: white; border: none; border-radius: 4px; cursor: pointer;">删除</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- ===== 分享给我的 ===== -->
          <div v-if="wishlistTab === 'shared-to-me'">
            <div v-if="!sharedWishlistsLoaded" style="text-align: center; padding: 20px; color: #999;">
              加载中...
            </div>
            <div v-else-if="sharedWishlists.length === 0" style="text-align: center; padding: 40px; color: #999;">
              暂无分享给您的志愿记录
            </div>
            <div v-else>
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr style="background: #f5f7fa;">
                    <th style="padding: 12px; border-bottom: 1px solid #e0e0e0; text-align: left;">名称</th>
                    <th style="padding: 12px; border-bottom: 1px solid #e0e0e0; text-align: left;">学生</th>
                    <th style="padding: 12px; border-bottom: 1px solid #e0e0e0; text-align: center;">志愿数</th>
                    <th style="padding: 12px; border-bottom: 1px solid #e0e0e0; text-align: center;">分享者</th>
                    <th style="padding: 12px; border-bottom: 1px solid #e0e0e0; text-align: center;">权限</th>
                    <th style="padding: 12px; border-bottom: 1px solid #e0e0e0; text-align: center;">分享时间</th>
                    <th style="padding: 12px; border-bottom: 1px solid #e0e0e0; text-align: center;">操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in sharedWishlists" :key="item.share_id" style="border-bottom: 1px solid #e0e0e0;">
                    <td style="padding: 12px;">
                      <div v-if="item.name && item.name.indexOf('（') > -1">
                        <div>{{ item.name.substring(0, item.name.indexOf('（')) }}</div>
                        <div style="font-size: 11px; color: #909399;">{{ item.name.substring(item.name.indexOf('（')) }}</div>
                      </div>
                      <div v-else>{{ item.name || '未命名' }}</div>
                    </td>
                    <td style="padding: 12px;">{{ item.student_name || '-' }}</td>
                    <td style="padding: 12px; text-align: center;">{{ item.item_count }}</td>
                    <td style="padding: 12px; text-align: center;">{{ item.shared_by_name }}</td>
                    <td style="padding: 12px; text-align: center;">
                      <span :style="{ color: item.permission === 'edit' ? '#67C23A' : '#909399', fontWeight: 'bold', fontSize: '13px' }">
                        {{ item.permission_display }}
                      </span>
                    </td>
                    <td style="padding: 12px; text-align: center;">{{ item.shared_at }}</td>
                    <td style="padding: 12px; text-align: center;">
                      <button @click="viewWishlistDetail(item.wishlist_id)" style="padding: 4px 12px; margin-right: 5px; background: #409EFF; color: white; border: none; border-radius: 4px; cursor: pointer;">查看</button>
                      <button v-if="item.permission === 'edit'" @click="loadSharedWishlistToTable(item.wishlist_id)" style="padding: 4px 12px; background: #67C23A; color: white; border: none; border-radius: 4px; cursor: pointer;">加载到表格</button>
                      <button v-else disabled style="padding: 4px 12px; background: #ccc; color: white; border: none; border-radius: 4px; cursor: not-allowed;">仅可查看</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer" style="padding: 15px; text-align: right; border-top: 1px solid #e0e0e0;">
          <button type="button" class="btn btn-cancel" @click="closeWishlistHistoryDialog">关闭</button>
        </div>
      </div>
    </div>

    <!-- 分享对话框 -->
    <div v-if="showShareDialog" class="modal-overlay" @click.self="closeShareDialog">
      <div class="modal" style="width: 450px;">
        <div class="modal-header">
          <h3>分享志愿表</h3>
          <button class="close-btn" @click="closeShareDialog">×</button>
        </div>
        <div class="modal-body">
          <div style="margin-bottom: 15px;">
            <label style="display: block; margin-bottom: 8px; font-weight: bold; color: #333;">被分享者手机号：</label>
            <input v-model="shareTargetPhone" type="text" placeholder="请输入对方的手机号" style="width: 100%; padding: 10px; border: 1px solid #dcdfe6; border-radius: 6px; box-sizing: border-box; font-size: 14px;">
          </div>
          <div style="margin-bottom: 15px;">
            <label style="display: block; margin-bottom: 8px; font-weight: bold; color: #333;">权限设置：</label>
            <label style="display: inline-flex; align-items: center; margin-right: 20px; cursor: pointer;">
              <input type="radio" v-model="sharePermission" value="view" style="margin-right: 5px;">
              <span>仅查看</span>
            </label>
            <label style="display: inline-flex; align-items: center; cursor: pointer;">
              <input type="radio" v-model="sharePermission" value="edit" style="margin-right: 5px;">
              <span>可编辑（可加载到表格）</span>
            </label>
          </div>
          <div v-if="shareErrorMessage" style="color: #F56C6C; font-size: 13px; margin-bottom: 10px;">
            {{ shareErrorMessage }}
          </div>
        </div>
        <div class="modal-footer" style="padding: 15px; text-align: right; border-top: 1px solid #e0e0e0;">
          <button type="button" class="btn btn-cancel" @click="closeShareDialog" style="margin-right: 10px;">取消</button>
          <button type="button" class="btn btn-primary" @click="confirmShare" :disabled="isSharing" style="padding: 8px 20px; background: #E6A23C; color: white; border: none; border-radius: 4px; cursor: pointer;">{{ isSharing ? '分享中...' : '确定分享' }}</button>
        </div>
      </div>
    </div>

    <!-- 志愿表详情弹窗 -->
    <div v-if="showWishlistDetailDialog" class="modal-overlay" @click.self="closeWishlistDetailDialog">
      <div ref="wishlistDetailModal" class="modal" style="width: 95%; max-width: 1000px; max-height: 90vh; overflow-y: auto;">
        <div class="modal-header">
          <h3>志愿表详情</h3>
          <button class="close-btn" @click="closeWishlistDetailDialog">×</button>
        </div>
        <div class="modal-body" ref="wishlistDetailBody">
          <div v-if="wishlistDetail" style="background: #f5f7fa; padding: 15px; border-radius: 4px; margin-bottom: 20px;">
            <p style="margin: 5px 0;"><strong>名称:</strong> {{ wishlistDetail.name || '未命名' }}</p>
            <p style="margin: 5px 0;"><strong>学生:</strong> {{ wishlistDetail.student_info?.student_name || '-' }} / {{ wishlistDetail.student_info?.gender || '-' }}</p>
            <p style="margin: 5px 0;"><strong>年份/科类/批次:</strong> {{ wishlistDetail.student_info?.admit_year }} / {{ wishlistDetail.student_info?.subject }} / {{ wishlistDetail.student_info?.batch }}</p>
            <p style="margin: 5px 0;"><strong>分数/位次:</strong> {{ wishlistDetail.student_info?.score }} / {{ wishlistDetail.student_info?.admission_rank }}</p>
            <p style="margin: 5px 0;"><strong>冲稳保设置:</strong> 冲{{ wishlistDetail.student_info?.rush_rank }} / 稳{{ wishlistDetail.student_info?.stable_rank }} / 保{{ wishlistDetail.student_info?.safe_rank }}</p>
            <p style="margin: 5px 0;" v-if="wishlistDetail.remark"><strong>备注:</strong> {{ wishlistDetail.remark }}</p>
          </div>
          <div v-if="wishlistDetail?.items?.length > 0">
            <div style="display: flex; align-items: center; justify-content: space-between; margin: 0 0 15px 0;">
              <h4 style="margin: 0; color: #409EFF;">志愿列表（共 {{ wishlistDetailGrouped.length }} 个院校专业组）</h4>
            </div>
            <table style="width: 100%; border-collapse: collapse; border: 1px solid #333; font-size: 14px;"
                   @click="clearWishDetailMovedHighlight">
              <thead>
                <tr style="background: #f5f7fa; border: 1px solid #333;">
                  <th style="border: 1px solid #333; padding: 10px; text-align: center; width: 30px;">
                    <input type="checkbox" @change="toggleAllDetailGroups"
                           :checked="wishDetailSelectedGroups.length === wishlistDetailGrouped.length && wishlistDetailGrouped.length > 0"
                           style="cursor: pointer;">
                  </th>
                  <th style="border: 1px solid #333; padding: 10px; text-align: center; width: 50px;">序号</th>
                  <th style="border: 1px solid #333; padding: 10px; text-align: center; width: 200px;">学校名-专业组</th>
                  <th style="border: 1px solid #333; padding: 10px; text-align: center;">专业名称</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="group in wishlistDetailDisplayGrouped">
                  <tr v-for="(major, mIdx) in group.majors" :key="group.key + '-' + mIdx"
                      :data-group-key="group.key"
                      :data-school="group.schoolName"
                      :data-major-idx="mIdx"
                      :style="{
                        background: (wishDetailMovedMajorKey && wishDetailMovedMajorKey.groupKey === group.key && wishDetailMovedMajorKey.majorIdx === mIdx) ? '#7ec8e3' : (wishDetailMovedKeys.includes(group.key) ? '#7ec8e3' : (wishDetailDropKey === group.key ? '#e6f7ff' : (major.risk === '冲' ? '#fff2f0' : major.risk === '稳' ? '#fffbe6' : major.risk === '保' ? '#f6ffed' : (group.groupIndex % 2 === 1 ? '#f0f5ff' : 'white'))))
                      }"
                      @dragover.prevent="onWishDragOver($event, group)"
                      @dragleave="onWishDragLeave"
                      @drop="onWishDrop($event, group, mIdx)"
                      @dragend="onWishDragEnd">
                    <td v-if="mIdx === 0" :rowspan="group.majors.length"
                        :style="{border: '1px solid #333', padding: '12px', textAlign: 'center', verticalAlign: 'middle', background: wishDetailMovedKeys.includes(group.key) ? 'transparent' : (group.groupIndex % 2 === 1 ? '#d6e4ff' : '#fafafa')}">
                      <input type="checkbox"
                             :checked="wishDetailSelectedGroups.includes(group.key)"
                             @change="toggleWishDetailGroupSelect(group)"
                             style="cursor: pointer; width: 16px; height: 16px;">
                    </td>
                    <td v-if="mIdx === 0" :rowspan="group.majors.length"
                        :style="{border: '1px solid #333', padding: '12px', textAlign: 'center', fontWeight: 'bold', fontSize: '16px', background: wishDetailMovedKeys.includes(group.key) ? 'transparent' : (group.groupIndex % 2 === 1 ? '#d6e4ff' : '#fafafa')}"
                        draggable="true"
                        @dragstart="onWishSchoolDragStart($event, group)"
                        @contextmenu.prevent="handleWishDetailContextMenu($event, group)"
                        title="拖动调节大组顺序">
                      <span style="cursor: grab; margin-right: 4px; color: #999; user-select: none;">⠿</span>
                      {{ group.groupIndex }}
                    </td>
                    <td v-if="mIdx === 0" :rowspan="group.majors.length"
                        :style="{border: '1px solid #333', padding: '12px', verticalAlign: 'middle', width: '200px', cursor: 'context-menu', background: wishDetailMovedKeys.includes(group.key) ? 'transparent' : (group.groupIndex % 2 === 1 ? '#d6e4ff' : '#fafafa')}"
                        @contextmenu.prevent="handleWishDetailContextMenu($event, group)">
                      <div style="font-size: 13px; line-height: 1.6;">
                        {{ group.schoolCode ? group.schoolCode + '-' : '' }}{{ group.schoolName }}{{ group.majorGroup ? group.majorGroup : '' }}
                      </div>
                      <div style="margin-top: 6px;">
                        <span @click.stop="deleteWishDetailGroup(group)"
                              title="删除整个大组"
                              class="no-export"
                              style="cursor: pointer; color: #fff; font-size: 13px; font-weight: bold; user-select: none; background: #ff4d4f; border-radius: 3px; padding: 2px 8px; display: inline-block; line-height: 1.4;">✕ 删除大组</span>
                      </div>
                    </td>
                    <td style="border: 1px solid #333; padding: 8px 10px; font-size: 13px; cursor: grab; user-select: none; word-break: break-word; overflow-wrap: break-word;"
                        :draggable="!major.isPlaceholder"
                        @dragstart="onWishMajorDragStart($event, group, mIdx)"
                        title="拖动调整专业顺序（仅限组内）">
                      <template v-if="!major.isPlaceholder">
                        <span style="display: inline-flex; align-items: center; justify-content: center; width: 22px; height: 22px; border-radius: 50%; background: #1890ff; color: #fff; font-size: 12px; font-weight: bold; margin-right: 6px;">{{ mIdx + 1 }}</span>
                        <span style="cursor: grab;">{{ major.majorCode ? major.majorCode + '-' : '' }}{{ major.majorName }}</span>
                        <span @click.stop="deleteWishDetailMajor(group, major, mIdx)"
                              title="删除此条专业"
                              class="no-export"
                              style="cursor: pointer; color: #fff; font-size: 14px; font-weight: bold; margin-left: 8px; user-select: none; background: #ff4d4f; border-radius: 3px; padding: 1px 6px; display: inline-block; line-height: 1.4;">✕</span>
                        <span style="margin-left: 10px;">
                          <span v-if="major.score" style="font-size: 13px; font-weight: bold;">{{ major.score }}</span>
                          <span v-if="major.rank" style="font-size: 12px; color: #666; margin-left: 8px;">位次: {{ major.rank }}</span>
                        </span>
                        <span v-if="major.rnk_gas != null && major.rnk_gas !== ''" style="font-size: 12px; margin-left: 8px;" :style="{color: major.rnk_gas < 0 ? '#ff4d4f' : (major.rnk_gas > 0 ? '#52c41a' : '#999')}" :title="'位差（最低位次-用户位次，正值有优势）'">
                          位差{{ major.rnk_gas > 0 ? '+' : '' }}{{ major.rnk_gas }}
                        </span>
                        <span v-if="major.scale_change != null && major.scale_change !== ''" style="font-size: 12px; margin-left: 8px;" :style="{color: major.scale_change > 0 ? '#52c41a' : (major.scale_change < 0 ? '#ff4d4f' : '#999')}" :title="'扩缩招（计划数-往年数）'">
                          {{ formatPlanDiff(major.scale_change) }}
                        </span>
                        <span v-if="major.risk" style="font-size: 12px; font-weight: bold; margin-left: 8px;" :style="{color: major.risk === '冲' ? '#ff4d4f' : major.risk === '稳' ? '#faad14' : major.risk === '保' ? '#52c41a' : '#333'}">
                          {{ major.risk }}
                        </span>
                      </template>
                      <template v-else>
                        <span>&nbsp;</span>
                      </template>
                      <span v-if="!major.isPlaceholder && isLastNonPlaceholder(mIdx, group.majors)"
                            style="font-size: 12px; color: #888; margin-left: 10px;">
                        (本组最低: {{ getGroupActualMinScore(group) }}分/{{ getGroupActualMinRank(group) }}位
                        <span v-if="getGroupActualMinRankDiff(group) !== null"
                              :style="{color: getGroupActualMinRankDiff(group) > 0 ? '#52c41a' : (getGroupActualMinRankDiff(group) < 0 ? '#ff4d4f' : '#999')}">
                          &nbsp;位差{{ getGroupActualMinRankDiff(group) > 0 ? '+' : '' }}{{ getGroupActualMinRankDiff(group) }})
                        </span>
                      </span>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 志愿表详情大组右键菜单 -->
        <div v-if="wishDetailContextMenuVisible"
             class="wish-detail-context-menu context-menu"
             :style="{ left: wishDetailContextMenuX + 'px', top: wishDetailContextMenuY + 'px' }">
          <div class="context-menu-item" @click="moveSchoolToTop">置顶</div>
          <div class="context-menu-item" @click="moveSchoolToBottom">置底</div>
          <div class="context-menu-divider"></div>
          <div class="context-menu-item" @click="partialSortSelectedGroups"
               :class="{ 'context-menu-item-disabled': wishDetailSelectedGroups.length === 0 }">选中排序</div>
        </div>
        <div class="modal-footer" style="padding: 15px; text-align: right; border-top: 1px solid #e0e0e0; display: flex; align-items: center; justify-content: flex-end;">
          <button type="button" class="btn btn-info" @click="partialSortSelectedGroups"
                  :disabled="wishDetailSelectedGroups.length === 0"
                  style="margin-right: 10px; flex: none;">选中排序</button>
          <label style="cursor: pointer; user-select: none; font-size: 14px; margin-right: 10px; padding: 10px 16px; border: none; border-radius: 4px; background-color: #f0f0f0; color: #666; display: inline-flex; align-items: center; transition: background-color 0.3s;"
                 onmouseover="this.style.backgroundColor='#e0e0e0'"
                 onmouseout="this.style.backgroundColor='#f0f0f0'">
            <input type="checkbox"
                   :checked="wishDetailRemovedEmpties.length > 0"
                   @change="toggleAllEmpties"
                   style="width: 16px; height: 16px; margin-right: 6px; cursor: pointer;">
            <span>删除空行</span>
          </label>
          <button type="button" class="btn btn-primary" @click="exportWishlistDetail" style="margin-right: 10px; flex: none;">导出Excel</button>
          <button type="button" class="btn btn-success" @click="exportWishlistImage" style="margin-right: 10px; flex: none;">导出图片</button>
          <button type="button" class="btn btn-warning" @click="exportWishlistPDF" style="margin-right: 10px; flex: none;">导出PDF</button>
          <select v-model="pdfMarginMode" style="margin-right: 10px; height: 32px; font-size: 12px; padding: 0 4px; border-radius: 4px; border: 1px solid #ccc; outline: none;">
            <option value="normal">Word普通(上下2.54左右3.17)</option>
            <option value="narrow">Word窄(上下1.27左右1.27)</option>
            <option value="custom">上2.54左右1.5下2.54</option>
          </select>
          <button type="button" class="btn btn-cancel" @click="closeWishlistDetailDialog" style="flex: none;">关闭</button>
        </div>
      </div>
    </div>

  <!-- 志愿记录引导提示弹窗 -->
  <div v-if="showWishlistGuide" class="guide-overlay" @click="closeWishlistGuide">
    <div class="guide-tooltip" @click.stop>
      <div class="guide-content">
        <p>点击下方按钮查看您的志愿记录</p>
        <button class="guide-btn" @click="closeWishlistGuide">查看志愿记录</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
// 直接导入HomePage.js文件作为组件配置
import HomePage from './HomePage.js'

// 导出导入的组件配置
export default HomePage
</script>

<style scoped>
/* 筛选区域布局：大屏flex等宽，小屏grid三列 */
.filter-area-top, .filter-area-bottom {
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: center;
  gap: 10px;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 10px;
}
.filter-area-top {
  background-color: #e3f2fd;
}
.filter-area-bottom {
  background-color: #fff3e0;
}
.filter-area-top > div:not([class]),
.filter-area-bottom > div:not([class]) {
  flex: 1;
  min-width: 80px;
}
@media (max-width: 768px) {
  .filter-area-top, .filter-area-bottom {
    display: grid !important;
    grid-template-columns: repeat(3, 1fr) !important;
  }
  .filter-area-top > div:not([class]),
  .filter-area-bottom > div:not([class]) {
    flex: none;
    min-width: 0;
  }
  .filter-area-full-row {
    grid-column: 1 / -1;
  }
}
/* 增强Element UI表格头部样式优先级 */
:deep(.el-table__header th) {
  background-color: #1976d2 !important;
  color: white !important;
}

/* 增强表头单元格样式优先级 */
:deep(.el-table__header .cell) {
  color: white !important;
}

/* 表格表头样式调整 */
:deep(.el-table >>> .el-table__header th ){
  min-width: 30px;
  padding: 0;
  height: 80px; /* 为竖排文字提供足够高度 */
}

/* 表头单元格样式 */
.el-table >>> .el-table__header .cell {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  word-break: break-all;
}

/* 单元格内容限制在4行 */
.el-table >>> .cell {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
 
}

/* 年份最大行的样式 */
.el-table >>> .latest-year-row {
  /* background-color: #fed5f4 !important; */
  color:blue !important;
  /* border: 4px solid #fba8a8 !important; */
  /* font-weight: 'bold' !important; */
}

/* 确保添加了这些冲稳保样式，并增加样式优先级 */
:deep(.risk-high) {
  background-color: #fff2f0 !important;
  color: #ff4d4f !important;
}
:deep(.risk-medium) {
  background-color: #fffbe6 !important;
  color: #faad14 !important;
}
:deep(.risk-low) {
  background-color: #f6ffed !important;
  color: #52c41a !important;
}

/* 同时保留原有样式作为后备 */
.el-table >>> .risk-high {
  background-color: #fff2f0 !important;
  color: #ff4d4f !important;
}
.el-table >>> .risk-medium {
  background-color: #fffbe6 !important;
  color: #faad14 !important;
}
.el-table >>> .risk-low {
  background-color: #f6ffed !important;
  color: #52c41a !important;
}

/* 负值单元格紫色背景显示 */
:deep(.negative-value) {
  background-color: #e975fd !important;
  color: #070007 !important;
  font-weight: 500;
}

.el-table >>> .negative-value {
  background-color: #e975fd !important;
  color: #070007 !important;
  font-weight: 500;
}

/* 专业组单元格背景色 - 增强特异性以防止被选中行覆盖 */
:deep(.wishtable .major-group-bg-0) {
  background-color: #37b9f5 !important;
}

:deep(.wishtable .major-group-bg-1) {
  background-color: #aea2fc !important;
}

.el-table >>> .wishtable .major-group-bg-0 {
  background-color: #37b9f5 !important;
}

.el-table >>> .wishtable .major-group-bg-1 {
  background-color: #aea2fc !important;
}



.custom-table {
  /* 启用硬件加速 */
  transform: translateZ(0);
  backface-visibility: hidden;
  
  /* 优化滚动性能 */
  -webkit-overflow-scrolling: touch;
}

/* 确保el-table横向滚动条始终显示 */
:deep(.el-table__body-wrapper) {
  overflow-x: auto !important;
}

/* 优化单元格渲染 */
.el-table__row {
  contain: layout style;
}

.el-table__cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: none !important; /* 移除过渡效果以提升性能 */
}

.page-header {
  display: flex;
  justify-content: space-between; /* 确保标题和按钮区域分开 */
  align-items: center;
  padding: 10px 20px;
  background-color: #4a67fb;
  border-bottom: 1px solid #e0e0e0;
}

.page-header h1 {
  flex: 1; /* 让标题占据剩余空间 */
  text-align: center; /* 文本居中 */
  margin: 0;
  color: white; /* 确保文字颜色与蓝色背景形成对比 */
}

.auth-buttons {
  /* 确保按钮区域不被压缩 */
  flex-shrink: 0;
}


.auth-btn {
  padding: 5px 15px;
  background-color: #0482ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
}

.auth-btn:hover {
  background-color: #66b1ff;
}

/* 第一个区域特殊样式 - 在所有屏幕尺寸下生效 */
.form-columns:first-of-type {
  display: flex !important;
  flex-wrap: wrap !important;
  overflow-x: visible !important;
  grid-template-columns: none !important;
  box-sizing: border-box !important;
  gap: 5px !important; /* 减小间隙 */
}

.form-columns:first-of-type > .form-group {
  flex: 0 0 130px !important; /* 固定宽度，不伸缩 */
  min-width: 130px !important;
  max-width: 130px !important; /* 固定最大宽度 */
  width: 130px !important; /* 固定宽度 */
  margin-right: 2px !important; /* 右边距 */
  margin-bottom: 8px !important; /* 加大与下方控件的间隙 */
}

/* 统一第一个区域的标签和控件字体大小 - 与第二个区域一致 */
.form-columns:first-of-type > .form-group {
  gap: 8px !important; /* 加大标签与控件之间的间隙 */
}

.form-columns:first-of-type > .form-group label {
  font-size: 16px !important;
}

.form-columns:first-of-type > .form-group input,
.form-columns:first-of-type > .form-group select {
  font-size: 13px !important;
  height: 36px !important;
}

/* 分页布局优化 */
.pagination-row {
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.pagination-row .el-pagination {
  display: inline-block;
}

/* 第一行：共X个学校和每页条数 */
.pagination-row.first-row {
  gap: 10px;
}

/* 第二行：页码 */
.pagination-row.second-row {
  margin-top: 5px;
}

/* 自定义分页样式 */
.custom-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.pagination-btn {
  padding: 6px 12px;
  background-color: #f5f7fa;
  border: 1px solid #409EFF;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  color: #606266;
}

.pagination-btn:hover:not(:disabled) {
  background-color: #409EFF;
  color: white;
  border-color: #409EFF;
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-btn.next-page-btn {
  position: relative;
}

.page-numbers {
  display: flex;
  gap: 5px;
}

.page-number {
  position: relative;
  min-width: 32px;
  height: 32px;
  padding: 0;
  background-color: #fff;
  border: 1px solid #409EFF;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  color: #606266;
  text-align: center;
  line-height: 32px;
}

.page-number:hover {
  background-color: #ecf5ff;
  border-color: #409EFF;
}

.page-number.active {
  background-color: #409EFF;
  color: white;
  border-color: #409EFF;
}

.page-number.page-vip {
  position: relative;
}

.page-vip-badge {
  position: absolute;
  top: -6px;
  right: -4px;
  background: linear-gradient(135deg, #FFD700, #FFA500);
  color: #fff;
  border-radius: 6px;
  padding: 0 3px;
  font-size: 8px;
  font-weight: bold;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
  z-index: 10;
  line-height: 14px;
}

/* 选项卡激活样式 */
.tab-active {
  color: #409EFF !important;
  border-bottom-color: #409EFF !important;
}

/* VIP角标样式 */
.vip-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: linear-gradient(135deg, #FFD700, #FFA500);
  color: #fff;
  border-radius: 10px;
  padding: 1px 6px;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

/* 按钮悬停效果 - 只变色不加阴影 */
/* 我的志愿记录按钮 */
.home-page .wishlist-btn:hover {
  background-color: #85ce61 !important;
}

/* 院校库专业库按钮 */
.home-page .majors-btn:hover {
  background-color: #66b1ff !important;
}

/* 完善我的志愿按钮 */
.home-page .wish-button.vip-badge-vip:hover {
  background: linear-gradient(135deg, #7b8eef 0%, #8a5bb2 100%) !important;
}

/* 消息按钮 */
.home-page .message-btn:hover {
  background-color: #42A5F5 !important;
}

/* 列筛选按钮 - 参考wish-button样式，不自适应宽度 */
.home-page .column-filter-btn {
  padding: 6px 14px;
  font-size: 13px;
  text-align: center;
  background-color: #1976d2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.home-page .column-filter-btn:hover {
  background-color: #ff69b4;
}

/* 列筛选激活时列名样式 */
.home-page .column-filter-label.filter-active {
  color: #409EFF;
  text-decoration: underline;
  cursor: pointer;
}

/* 列筛选标志图标 */
.home-page .column-filter-badge {
  color: #ff9800;
  font-size: 12px;
  line-height: 1;
}

/* 问题反馈按钮 */
.home-page .feedback-btn:hover {
  background-color: #ffb74d !important;
}

/* 按钮过渡效果 */
.home-page .auth-btn,
.home-page .message-btn,
.home-page .feedback-btn {
  transition: background-color 0.3s ease;
}

/* 响应式设计 - 手机端垂直布局 */
@media (max-width: 768px) {
  .home-page {
    width: 100%;
    overflow-x: visible; /* 改为visible，允许内容溢出 */
  }

  .page-header {
    flex-direction: column;
    padding: 10px;
    gap: 10px;
  }

  .page-header h1 {
    font-size: 18px !important;
    text-align: center;
    width: 100%;
  }

  .page-header .auth-btn {
    padding: 6px 10px;
    font-size: 12px;
  }

  .search-conditions-container {
    padding: 0 10px;
    width: 100%;
    box-sizing: border-box;
  }
  
  .search-conditions {
    width: 100%;
  }
  
  .search-conditions form {
    width: 100%;
  }

  /* 表单改为每行3个控件（标签+输入框），从左到右依次排列 */
  .form-columns {
    display: grid !important;
    grid-template-columns: repeat(3, 1fr) !important;
    gap: 8px !important;
    padding-right: 8px; /* 右边间隙 */
    justify-items: start; /* 左对齐 */
  }
  
  /* 第一个区域使用flex布局，自动换行 */
  .form-columns:first-of-type {
    display: flex !important;
    flex-wrap: wrap !important;
    overflow-x: visible !important;
    grid-template-columns: none !important;
    box-sizing: border-box !important;
    gap: 5px !important;
  }
  
  /* 第一个区域的form-group样式 - 使用更高优先级 */
  .form-columns:first-of-type > .form-group {
    flex: 0 0 130px !important;
    min-width: 130px !important;
    max-width: 130px !important;
    width: 130px !important;
    margin-right: 2px !important;
    margin-bottom: 8px !important;
  }
  
  .form-columns:first-of-type > .form-group {
    gap: 8px !important;
  }
  
  .form-columns:first-of-type > .form-group label {
    font-size: 16px !important;
  }
  
  .form-columns:first-of-type > .form-group input,
  .form-columns:first-of-type > .form-group select {
    font-size: 13px !important;
    height: 36px !important;
  }

  .form-columns .form-group {
    width: 100% !important;
    min-width: auto !important;
    flex: none !important;
    display: flex;
    flex-direction: column;
    gap: 3px;
    margin-bottom: 0;
    align-items: flex-start; /* 左对齐 */
  }

  .form-group label {
    justify-content: flex-start !important;
    font-size: 16px;
    min-height: 20px;
    line-height: 1.2;
    white-space: normal;
    overflow: visible;
    text-align: left;
    word-break: break-all;
  }

  .form-group input,
  .form-group select {
    width: 100% !important;
    min-width: auto !important;
    height: 36px;
    padding: 0 5px;
    font-size: 13px;
    box-sizing: border-box;
  }

  /* 科类和位次设置改为垂直，左对齐 */
  .form-group[style*="flex-wrap"] {
    flex-direction: column !important;
    align-items: flex-start !important;
  }

  .form-group[style*="flex-wrap"] > div {
    justify-content: flex-start !important;
    width: 100% !important;
  }

  .form-group[style*="flex-wrap"] label {
    text-align: left !important;
    justify-content: flex-start !important;
  }

  .form-group > div[style*="flex"] {
    flex-direction: column !important;
    width: 100% !important;
    align-items: flex-start !important;
  }

  .range-settings {
    flex-direction: row !important;
    justify-content: flex-start;
    gap: 8px;
  }

  .range-settings input,
  .range-settings select {
    flex: 0 0 auto;
    width: 80px !important;
  }

  /* 专业表格改为卡片式 */
  .professional-table {
    display: block;
    width: 100%;
  }

  .professional-table thead {
    display: none; /* 隐藏表头 */
  }

  .professional-table tbody {
    display: block;
    width: 100%;
  }

  .professional-table tr {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
  }

  .professional-table td {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    padding: 6px 8px;
    border: none;
  }

  .professional-table td::before {
    content: attr(data-label);
    font-weight: bold;
    color: #666;
    font-size: 12px;
  }

  .professional-table td input,
  .professional-table td select {
    width: 100%;
    font-size: 13px;
    box-sizing: border-box;
  }

  /* 修复学校名单元格内的div布局，使其与其他单元格一致 */
  .professional-table td > div {
    width: 100%;
  }

  /* 每组条件用背景色区分 - 由JavaScript动态控制 */
  .professional-table tbody tr {
    border-bottom: 1px solid #ddd;
  }

  /* 按钮组垂直排列 */
  .button-group {
    gap: 10px !important;
  }

  .button-group > div {
    flex-direction: column !important;
    gap: 10px !important;
  }

  .button-group button {
    width: 100% !important;
    padding: 12px;
    font-size: 14px;
  }

  /* 增加条件、删除条件按钮小屏两列布局 */
  .condition-buttons-row {
    display: flex !important;
    flex-direction: row !important;
    gap: 10px !important;
    flex-wrap: wrap !important;
  }

  .condition-buttons-row button {
    flex: 1 !important;
    width: auto !important;
    min-width: 0 !important;
  }

  /* 超级管理员按钮区域小屏换行显示 */
  .condition-buttons-row .admin-buttons-group {
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 8px !important;
    width: 100% !important;
  }

  .condition-buttons-row .admin-btn,
  .condition-buttons-row .admin-btn2 {
    flex: 1 1 calc(50% - 5px) !important;
    min-width: 140px !important;
    font-size: 12px !important;
    padding: 8px 4px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .condition-buttons-row .admin-buttons-group select {
    flex: 1 1 100% !important;
    width: 100% !important;
    margin-bottom: 5px !important;
  }

  /* 操作按钮区域小屏布局：筛选志愿单独一行，其他两列 */
  .action-buttons-row {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 10px !important;
    width: 100% !important;
  }

  .action-buttons-row .search-btn {
    grid-column: 1 / -1 !important;
    width: 100% !important;
    padding: 12px;
    font-size: 14px;
  }

  .action-buttons-row .search-btn:hover {
    background-color: #C71585 !important;
  }

  .action-buttons-row button:not(.search-btn) {
    width: 100% !important;
    flex: none !important;
    padding: 12px;
    font-size: 14px;
  }

  /* 表格横向滚动改为卡片式 */
  .el-table {
    font-size: 12px;
  }

  .el-table .cell {
    white-space: normal !important;
    line-height: 1.4;
  }

  /* 小屏下分页布局优化 */
  .pagination-row {
    flex-direction: column;
    gap: 5px;
  }
  
  .pagination-row.first-row {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 5px;
    align-items: center;
    justify-content: center;
  }
  
  .pagination-row.first-row .el-pagination {
    width: auto;
  }
  
  .pagination-row.second-row {
    margin-top: 0;
  }
  
  .pagination-row .el-pagination {
    width: 100%;
    justify-content: center;
  }

  /* 小屏下header按钮布局 */
  .home-page .page-header {
    flex-direction: column !important;
    align-items: center !important;
    gap: 10px !important;
  }

  .home-page .page-header h1 {
    width: 100% !important;
    text-align: center !important;
    font-size: 18px !important;
  }

  /* 按钮容器 - 三列两行布局 */
  .home-page .page-header > div {
    display: grid !important;
    grid-template-columns: repeat(3, 1fr) !important;
    grid-template-rows: repeat(2, 1fr) !important;
    gap: 8px !important;
    width: 100% !important;
    justify-items: stretch !important;
    align-items: stretch !important;
  }

  /* 我的按钮第一行第一列 */
  .home-page .page-header > div > div:first-of-type {
    grid-column: 1 / 2 !important;
    grid-row: 1 / 3 !important;
    display: flex !important;
    flex-direction: column !important;
    width: 100% !important;
    height: 100% !important;
  }

  .home-page .page-header > div > div:first-of-type .auth-btn {
    height: 100% !important;
    min-height: 48px !important;
    width: 100% !important;
    margin: 0 !important;
  }

  /* 用户名按钮第一行第二列 */
  .home-page .auth-buttons .username {
    grid-column: 2 / 3 !important;
    grid-row: 1 !important;
    height: 100% !important;
    min-height: 48px !important;
    width: 100% !important;
    margin: 0 !important;
  }

  /* 退出登录按钮第二行第二列 */
  .home-page .auth-buttons .auth-btn:not(.username) {
    grid-column: 2 / 3 !important;
    grid-row: 2 !important;
    height: 100% !important;
    min-height: 48px !important;
    width: 100% !important;
    margin: 0 !important;
  }

  /* 消息按钮第一行第三列 */
  .home-page .message-feedback-group .message-btn {
    grid-column: 3 / 4 !important;
    grid-row: 1 !important;
    height: 100% !important;
    min-height: 48px !important;
    width: 100% !important;
    margin: 0 !important;
  }

  /* 问题反馈按钮第二行第三列 */
  .home-page .message-feedback-group .feedback-btn {
    grid-column: 3 / 4 !important;
    grid-row: 2 !important;
    height: 100% !important;
    min-height: 48px !important;
    width: 100% !important;
    margin: 0 !important;
  }

  /* 未登录状态 - 登录按钮第一行第二列 */
  .home-page .auth-buttons > .auth-buttons-guest .auth-btn:first-child {
    grid-column: 2 / 3 !important;
    grid-row: 1 !important;
    height: 100% !important;
    min-height: 48px !important;
    width: 100% !important;
    margin: 0 !important;
  }

  /* 未登录状态 - 注册按钮第二行第二列 */
  .home-page .auth-buttons > .auth-buttons-guest .auth-btn:last-child {
    grid-column: 2 / 3 !important;
    grid-row: 2 !important;
    height: 100% !important;
    min-height: 48px !important;
    width: 100% !important;
    margin: 0 !important;
  }

  /* 消息反馈组重置为contents */
  .home-page .message-feedback-group,
  .home-page .auth-buttons,
  .home-page .auth-buttons > div {
    display: contents !important;
  }
}

@media (max-width: 480px) {
  .page-header h1 {
    font-size: 16px !important;
  }

  .auth-btn {
    padding: 6px 8px;
    font-size: 11px;
  }

  .form-group label {
    font-size: 13px;
  }
}

/* 导入弹窗拖放区域样式 */
.import-drop-zone {
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  padding: 40px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #fafafa;
}

.import-drop-zone:hover {
  border-color: #409EFF;
  background-color: #f0f7ff;
}

.import-drop-zone.el-icon-upload {
  display: block;
}

/* 全屏导入弹窗样式 */
.import-dialog-fullscreen {
  margin: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  max-width: 100vw !important;
  max-height: 100vh !important;
  top: 0 !important;
  left: 0 !important;
  position: fixed !important;
  background-color: transparent !important;
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
}

.import-dialog-fullscreen .el-dialog__header {
  background-color: transparent !important;
  background: transparent !important;
  border-bottom: none !important;
}

.import-dialog-fullscreen .el-dialog__title {
  color: #333 !important;
}

.import-dialog-fullscreen .el-dialog__body {
  height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: transparent !important;
  background: transparent !important;
  padding: 20px !important;
}

.import-dialog-fullscreen .el-dialog__headerbtn .el-dialog__close {
  color: #333 !important;
}

.import-drop-zone-fullscreen {
  border: 3px dashed #d9d9d9;
  border-radius: 12px;
  padding: 100px 40px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  background-color: transparent;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 20px;
}

.import-drop-zone-fullscreen:hover {
  border-color: #409EFF;
  background-color: rgba(64, 158, 255, 0.1);
}

/* 上下文菜单样式 */
.context-menu {
  position: fixed;
  z-index: 9999;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 150px;
  padding: 8px 0;
  animation: fadeIn 0.2s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.context-menu-item {
  padding: 12px 16px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.context-menu-item:hover {
  background-color: #f0f0f0;
}

.context-menu-item:active {
  background-color: #e0e0e0;
}

.context-menu-divider {
  height: 1px;
  background-color: #e8e8e8;
  margin: 4px 8px;
}

.context-menu-item-disabled {
  color: #bbb !important;
  cursor: not-allowed !important;
}
.context-menu-item-disabled:hover {
  background-color: transparent !important;
}

/* 小屏时菜单样式优化 */
@media (max-width: 768px) {
  .context-menu {
    min-width: 130px;
    font-size: 13px;
  }

  .context-menu-item {
    padding: 10px 14px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .context-menu {
    min-width: 120px;
  }

  .context-menu-item {
    padding: 8px 12px;
    font-size: 12px;
  }
}

/* 反馈弹窗专用样式 */
.feedback-modal-container {
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.feedback-modal-container h3 {
  margin: 0 0 10px 0;
  color: #333;
  text-align: center;
  font-size: 20px;
}

.feedback-modal-container .modal-desc {
  color: #666;
  font-size: 14px;
  text-align: center;
  margin-bottom: 25px;
}

/* 表单布局 */
.feedback-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.feedback-form-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.feedback-label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  display: flex;
  align-items: center;
  gap: 4px;
}

.feedback-label .required {
  color: #f44336;
}

.feedback-label .optional {
  color: #999;
  font-weight: normal;
  font-size: 13px;
}

.feedback-textarea,
.feedback-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
  transition: border-color 0.3s;
}

.feedback-textarea:focus,
.feedback-input:focus {
  outline: none;
  border-color: #4a67fb;
}

.feedback-textarea {
  resize: vertical;
  min-height: 100px;
}

/* 图片上传区域样式 */
.image-upload-wrapper {
  display: flex;
  align-items: stretch;
  gap: 10px;
}

.image-upload-area {
  flex: 1;
  border: 2px dashed #ddd;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #fafafa;
  min-height: 120px;
  outline: none;
}

.upload-image-btn {
  width: 100px;
  min-width: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px;
  background-color: #f5f7fa;
  border: 2px solid #e4e7ed;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 13px;
  color: #606266;
}

.upload-image-btn:hover {
  background-color: #ecf5ff;
  border-color: #4a67fb;
  color: #4a67fb;
}

.upload-image-btn span:first-child {
  font-size: 24px;
}

.image-upload-area:hover,
.image-upload-area:focus {
  border-color: #4a67fb;
  background-color: #f0f4ff;
}

.upload-placeholder {
  color: #999;
}

.upload-placeholder p {
  margin: 5px 0;
}

.image-preview-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-start;
}

.image-preview-item {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #ddd;
}

.image-preview-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: zoom-in;
}

.remove-image-btn {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: rgba(255, 0, 0, 0.8);
  color: white;
  border: none;
  cursor: pointer;
  font-size: 12px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.remove-image-btn:hover {
  background-color: rgba(255, 0, 0, 1);
}

.add-more-images {
  width: 80px;
  height: 80px;
  border: 2px dashed #4a67fb;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #4a67fb;
  cursor: pointer;
  background-color: #f0f4ff;
}

.add-more-images span {
  font-size: 20px;
  font-weight: bold;
}

.add-more-images p {
  margin: 2px 0 0 0;
  font-size: 11px;
}

.image-count-hint {
  font-size: 12px;
  color: #666;
  margin: 5px 0 0 0;
}

/* 反馈弹窗按钮 */
.feedback-modal-buttons {
  display: flex;
  gap: 12px;
  margin-top: 25px;
}

.feedback-btn-cancel,
.feedback-btn-confirm {
  flex: 1;
  padding: 12px;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s;
}

.feedback-btn-cancel {
  background-color: #f0f0f0;
  color: #666;
}

.feedback-btn-cancel:hover {
  background-color: #e0e0e0;
}

.feedback-btn-confirm {
  background-color: #4a67fb;
  color: white;
}

.feedback-btn-confirm:hover:not(:disabled) {
  background-color: #3a57eb;
}

.feedback-btn-confirm:disabled {
  background-color: #a5b4fc;
  cursor: not-allowed;
}

/* 通用弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.modal .modal-header {
  padding: 15px 20px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal .modal-header h3 {
  margin: 0;
  color: #333;
}

.modal .close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.modal .close-btn:hover {
  color: #333;
}

.modal .modal-body {
  padding: 15px 20px;
}

.modal .modal-footer {
  padding: 15px 20px;
  border-top: 1px solid #e0e0e0;
  text-align: right;
}

.modal .btn {
  padding: 8px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.modal .btn-cancel {
  background-color: #f0f0f0;
  color: #666;
}

.modal .btn-cancel:hover {
  background-color: #e0e0e0;
}

.modal .btn-primary {
  background-color: #409EFF;
  color: white;
}

.modal .btn-primary:hover {
  background-color: #66b1ff;
}

.modal-container {
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.modal-buttons {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.btn-cancel {
  flex: 1;
  padding: 10px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  background-color: #f0f0f0;
  color: #666;
  transition: background-color 0.3s;
}

.btn-cancel:hover {
  background-color: #e0e0e0;
}

/* ========== 消息通知样式 ========== */
.message-btn {
  position: relative;
}

.message-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #f44336;
  color: white;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
}

/* 用户身份角标样式 */
.user-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: linear-gradient(135deg, #FFD700, #FFA500);
  color: #fff;
  border-radius: 10px;
  padding: 1px 6px;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

/* 功能按钮VIP/SVIP角标样式 */
.feature-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  background: linear-gradient(135deg, #FFD700, #FFA500);
  color: #fff;
  border-radius: 8px;
  padding: 1px 5px;
  font-size: 9px;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  z-index: 10;
}

/* 按钮容器定位 */
.vip-badge-svip,
.vip-badge-vip {
  position: relative;
  overflow: visible;
}

.message-modal-container {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow: hidden;
}

.message-list {
  max-height: 60vh;
  overflow-y: auto;
}

.message-item {
  transition: background-color 0.2s;
}

.message-item:hover {
  background-color: #f5f5f5;
}

.message-item.unread {
  background-color: #e3f2fd;
  border-left: 3px solid #2196F3;
}

.message-item.unread:hover {
  background-color: #bbdefb;
}

.no-message {
  text-align: center;
  color: #999;
  padding: 40px;
}

/* ========== 列筛选样式 ========== */
.column-filter-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  cursor: default;
}

.column-filter-label {
  flex: 1;
}
.column-filter-icon {
  font-size: 13px;
  color: #c0c4cc;
  cursor: pointer;
  padding: 2px;
  flex-shrink: 0;
  transition: color 0.2s;
}
.column-filter-icon:hover {
  color: #409EFF;
}
.column-filter-icon.filter-active {
  color: #409EFF;
  font-weight: bold;
}
/* ========== 列筛选样式结束 ========== */

/* ========== 位次趋势弹窗样式 ========== */
.rank-value-hoverable {
  cursor: pointer;
  color: #409EFF;
  font-weight: 500;
  border-bottom: 1px dashed #409EFF;
}
.rank-value-hoverable:hover {
  color: #337ECC;
  border-bottom-color: #337ECC;
}
.trend-popover-inner {
  padding: 2px 0;
}
.trend-chart-title {
  font-size: 11px;
  color: #999;
  margin-bottom: 2px;
  text-align: center;
}
.trend-chart-svg {
  display: block;
  margin: 0 auto 4px;
}
.trend-legend {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 4px;
  font-size: 10px;
  color: #666;
  flex-wrap: wrap;
}
.trend-legend-item {
  display: flex;
  align-items: center;
  gap: 3px;
  white-space: nowrap;
}
.trend-legend-line {
  display: inline-block;
  width: 14px;
  height: 2px;
  border-radius: 1px;
}
.lrnk-line {
  background-color: #409EFF;
}
.hrnk-line {
  background-color: #F56C6C;
}
.myrnk-line {
  background: repeating-linear-gradient(90deg, #E6A23C 0px, #E6A23C 5px, transparent 5px, transparent 8px);
  width: 20px;
}
.plan-line {
  background-color: #67C23A;
}
.prepl-line {
  background: repeating-linear-gradient(90deg, #909399 0px, #909399 5px, transparent 5px, transparent 8px);
  width: 20px;
}
.trend-years-data {
  font-size: 11px;
  color: #333;
  margin-top: 4px;
}
.trend-year-row {
  display: flex;
  justify-content: space-between;
  padding: 1px 4px;
  gap: 4px;
}
.trend-year-row:not(:last-child) {
  border-bottom: 1px solid #f0f0f0;
}
.trend-year {
  color: #999;
  min-width: 36px;
}
.trend-lrnk {
  color: #409EFF;
  min-width: 48px;
  text-align: right;
}
.trend-ecnt {
  color: #67C23A;
  min-width: 32px;
  text-align: right;
  font-size: 10px;
}
.trend-ecnt-pre {
  color: #909399;
  min-width: 32px;
  text-align: right;
  font-size: 10px;
}
/* ========== 位次趋势弹窗样式结束 ========== */

/* 志愿表详情拖拽手柄悬停效果 */
.drag-handle {
  cursor: grab;
  user-select: none;
  opacity: 0.4;
  transition: opacity 0.2s;
}
.drag-handle:hover {
  opacity: 0.8;
}

/* ========== 志愿表全宽覆盖表格 ========== */
.wishtable .el-table th,
.wishtable .el-table td {
  padding: 6px 0 !important;
}
.wishtable .el-table--border th,
.wishtable .el-table--border td {
  padding: 6px 0 !important;
}
</style>

<style>
/* 志愿表选中行 - 不改变字体颜色也不覆盖特殊列背景，与筛选表一致 */
.wishtable .el-table__body tr.current-row > td:not(.negative-value):not(.major-group-bg-0):not(.major-group-bg-1),
.wishtable .el-table__body tr.table-row-selected > td:not(.negative-value):not(.major-group-bg-0):not(.major-group-bg-1) {
  background-color: #e1f5fe !important;
}

/* 强制加载提示显示在表格上部 */
.el-loading-mask .el-loading-spinner {
  top: 0 !important;
  margin-top: 0 !important;
  transform: none !important;
}

/* Element UI MessageBox 小屏适配 */
@media (max-width: 768px) {
  .el-message-box {
    width: 90% !important;
    max-width: 350px !important;
    min-width: 280px !important;
  }

  .el-message-box__content {
    padding: 15px !important;
    font-size: 14px !important;
  }

  .el-message-box__btns {
    padding: 10px 15px !important;
    display: flex !important;
    flex-direction: row !important;
    gap: 10px !important;
  }

  .el-message-box__btns .el-button {
    flex: 1 !important;
    padding: 10px 15px !important;
    font-size: 14px !important;
    margin: 0 !important;
  }

  .el-message-box__title {
    font-size: 16px !important;
  }
}

@media (max-width: 480px) {
  .el-message-box {
    width: 95% !important;
    max-width: 320px !important;
    min-width: 260px !important;
  }

  .el-message-box__content {
    padding: 12px !important;
    font-size: 13px !important;
  }

  .el-message-box__btns {
    padding: 8px 12px !important;
  }

  .el-message-box__btns .el-button {
    padding: 8px 12px !important;
    font-size: 13px !important;
  }

  .el-message-box__title {
    font-size: 15px !important;
  }
}

/* 志愿记录引导提示样式 */
.guide-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
}

.guide-tooltip {
  position: fixed;
  top: 70px;
  right: 180px;
  background-color: #4a4a4a;
  color: white;
  padding: 15px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 10000;
  max-width: 280px;
}

.guide-content {
  text-align: center;
}

.guide-content p {
  margin: 0 0 12px 0;
  font-size: 14px;
  line-height: 1.5;
}

.guide-btn {
  background-color: #67C23A;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.guide-btn:hover {
  background-color: #5cb82e;
}

/* ========== 列筛选弹窗样式（非scoped，弹窗渲染在body下） ========== */
.column-filter-popover {
  padding: 0 !important;
  min-width: 200px !important;
}
.column-filter-popover-content {
  padding: 10px;
}
.column-filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 8px;
}
.filter-option-list {
  max-height: 240px;
  overflow-y: auto;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 4px 0;
}
.filter-option-item {
  display: flex;
  align-items: center;
  padding: 4px 10px;
  cursor: pointer;
  transition: background-color 0.2s;
  gap: 6px;
}
.filter-option-item:hover {
  background-color: #f5f7fa;
}
.filter-option-item.select-all {
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 2px;
  font-weight: bold;
}
.filter-option-item input[type="checkbox"] {
  flex-shrink: 0;
}
.filter-option-text {
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.filter-option-count {
  font-size: 11px;
  color: #909399;
  margin-top: 4px;
  text-align: right;
}
/* ========== 列筛选弹窗样式结束 ========== */

/* ========== 专业名称考研方向悬停弹窗样式 ========== */
.maj-name-cell {
  font-size: 14px;
  color: #333;
}
.maj-name-hoverable {
  cursor: pointer;
  color: #409EFF;
  transition: color 0.2s;
}
.maj-name-hoverable:hover {
  color: #337ecc;
}
.major-graddir-popover .graddir-label {
  font-weight: 600;
  color: #409EFF;
  margin-bottom: 6px;
  font-size: 13px;
}
.major-graddir-popover .graddir-content {
  font-size: 13px;
  color: #333;
  line-height: 1.6;
  max-width: 280px;
  white-space: pre-wrap;
  word-break: break-all;
}
.major-graddir-popover .graddir-divider {
  height: 1px;
  background: #eee;
  margin: 8px 0;
}

/* ========== 自动排序弹窗（非scoped，el-dialog渲染在body下） ========== */
.sort-dialog {
  border-radius: 14px;
  overflow: hidden;
}
.sort-dialog .el-dialog__header {
  padding: 18px 24px 0;
  border-bottom: none;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
}
.sort-dialog .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.5px;
}
.sort-dialog .el-dialog__headerbtn .el-dialog__close {
  color: rgba(255,255,255,0.6);
  font-size: 18px;
}
.sort-dialog .el-dialog__headerbtn .el-dialog__close:hover {
  color: #fff;
}
.sort-dialog .el-dialog__body {
  padding: 24px 24px 0;
  background: #fafbfc;
}
.sort-body {
  padding: 0;
}
/* 左右对比布局 */
.sort-compare {
  display: flex;
  gap: 16px;
  width: 100%;
}
.sort-col {
  flex: 1;
  display: block !important;
  margin: 0 !important;
}
.sort-col .el-radio__input {
  display: none;
}
.sort-col .el-radio__label {
  display: block;
  width: 100%;
  padding: 0;
}
.sort-col-inner {
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  border: 2px solid transparent;
  transition: all 0.3s cubic-bezier(0.4,0,0.2,1);
  transform: translateY(0);
}
.sort-col-inner:hover {
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  transform: translateY(-2px);
  border-color: #d9e6f7;
}
/* 选中状态：.sort-col.is-checked 中间无空格，因为在同一元素上 */
.sort-col.is-checked .sort-col-inner {
  box-shadow: 0 4px 20px rgba(64,158,255,0.25);
  transform: translateY(-2px);
  border-color: #409eff;
}
.sort-col-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  background: #f8f9fb;
  border-bottom: 1px solid #eef0f2;
  transition: background 0.3s;
}
.sort-col.is-checked .sort-col-header {
  background: linear-gradient(135deg, #e8f0fe 0%, #f0f4ff 100%);
  border-bottom-color: #d0dfff;
}
.sort-col-badge {
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #e4e7ed;
  color: #909399;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
  transition: all 0.3s;
}
.sort-col.is-checked .sort-col-badge {
  background: linear-gradient(135deg, #409eff 0%, #337ecc 100%);
  color: #fff;
  box-shadow: 0 2px 6px rgba(64,158,255,0.3);
}
.sort-col-name {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  transition: color 0.3s;
}
.sort-col.is-checked .sort-col-name {
  color: #337ecc;
}
.sort-col-body {
  padding: 14px 16px 16px;
}
.sort-col-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 6px 0;
  font-size: 12.5px;
  line-height: 1.5;
}
.sort-col-row + .sort-col-row {
  border-top: 1px solid #f0f2f5;
}
.sort-col-key {
  color: #909399;
  flex-shrink: 0;
  min-width: 56px;
  padding-top: 1px;
}
.sort-col-val {
  color: #2c3e50;
  font-weight: 500;
}
/* 底部按钮 */
.sort-dialog .el-dialog__footer {
  padding: 16px 24px 20px;
  border-top: 1px solid #eef0f2;
  background: #fafbfc;
}
.sort-dialog .el-button--primary {
  border-radius: 8px;
  padding: 10px 28px;
  font-size: 13px;
  font-weight: 500;
  background: linear-gradient(135deg, #409eff 0%, #337ecc 100%);
  border: none;
  letter-spacing: 0.5px;
}
.sort-dialog .el-button--primary:hover {
  background: linear-gradient(135deg, #66b1ff 0%, #409eff 100%);
  box-shadow: 0 4px 12px rgba(64,158,255,0.35);
}
.sort-dialog .el-button--default {
  border-radius: 8px;
  padding: 10px 28px;
  font-size: 13px;
  font-weight: 500;
}
</style>
